import ReactDOM from "react-dom";
import React, { useState, useEffect, useRef, useMemo } from "react";
import { Modal, ToastContainer } from "react-bootstrap";
import { toast } from "react-toastify";
import axios from "axios";
import { useLocation } from "react-router-dom";
import Dashboardnavbar from "../../layout/Dashboardnavbar";
import {
  UpdatePencil,
  DeleteDustbin,
  ArrowBullet,
  SearchBig,
  CircularGrid,
  DownloadIcon,
} from "../AllSvg";
import { BASE_URL } from "../../config/axios";
import { handleErrorToast, DateRangePicker } from "../CustomFunctions";
import "./bid.css";
import {
  formatDateDDMMYYYY,
  formattedDateLong,
  formatDateDDMMYYYYmonth,
  formatDateIndian,
  formatDateDDMMYYYYmonthNew,
} from "../Date";
import * as XLSX from "xlsx";
import AimantraLoading from "../AimantraLoading/AimantraLoading";
import DownloadModal from "../DownloadModalEMD/DownloadModal";

// ! *************** Update BG Details Component ***************

const UpdateBgDetails = ({ i, getBgDetails, toggleState }) => {
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    bg_created: "",
    payer_bank: "",
    bg_creation_date: "",
    bg_expiry_date: "",
    ref_no: "",
    bg_created_on_behalf_of: "",
    bg_created_by: "",
    emd_type: "",
    bg_transcation_date: "",
    account_number: "",
    name_of_account_holder: "",
    transcation_id: "",
    emd_created_proof: [],
    insurer_company: "",
    payee_name: "",
    emd_type_multi: [],
    cost_of_rfp: "",
    cost_of_rfp_mode: "",
  });
  const [isOtherMode, setIsOtherMode] = useState(false);
  const [rfpModeCustom, setRfpModeCustom] = useState("");

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  // ── Build dropdown options from both emd_type and emd_type_multi ──
  // If emd_type_multi has values → show those
  // If only emd_type has value → show that
  // Always include standard valid choices too
  const validChoices = [
    { key: "Bank_Gurantee", value: "Bank Guarantee" },
    { key: "neft", value: "NEFT" },
    { key: "demand_draft", value: "Demand Draft" },
    { key: "suretybond", value: "Surety Bond" },
    { key: "card", value: "Card" },
    { key: "other", value: "Other" },
  ];
  const validKeys = new Set(validChoices.map((v) => v.key));

  const EmdType = useMemo(() => {
    const multi = Array.isArray(i.emd_type_multi) ? i.emd_type_multi : [];
    const single = i.emd_type ? [i.emd_type] : [];

    // All types from record (multi takes priority, add single if not already there)
    const recordTypes = [...new Set([...multi, ...single])];

    // Custom types = types in record not in standard validChoices
    const customTypes = recordTypes
      .filter((t) => !validKeys.has(t))
      .map((t) => ({
        key: t,
        value: t.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()),
      }));

    // Standard choices first, then custom ones at bottom
    return [...validChoices, ...customTypes];
  }, [i.emd_type, i.emd_type_multi]);

  useEffect(() => {
    if (show) {
      const multi = Array.isArray(i.emd_type_multi) ? i.emd_type_multi : [];
      const initialEmdType = multi.length > 0 ? multi[0] : i.emd_type || "";

      // rfpModeCustom pre-fill
      const standardModes = ["online", "offline"];
      const storedMode = i.cost_of_rfp_mode || "";
      if (storedMode && !standardModes.includes(storedMode)) {
        setRfpModeCustom(storedMode);
        setIsOtherMode(true);
      } else {
        setRfpModeCustom("");
        setIsOtherMode(false);
      }

      setFormData({
        bg_created: i.bg_created || false,
        payer_bank: i.payer_bank || "",
        bg_creation_date: i.bg_creation_date ? i.bg_creation_date.split("T")[0] : "",
        bg_expiry_date: i.bg_expiry_date ? i.bg_expiry_date.split("T")[0] : "",
        ref_no: i.ref_no || "",
        bg_created_on_behalf_of: i.bg_created_on_behalf_of || "",
        bg_created_by: i.bg_created_by || "",
        emd_type: initialEmdType,
        bg_transcation_date: i.bg_transcation_date || "",
        account_number: i.account_number || "",
        name_of_account_holder: i.name_of_account_holder || "",
        transcation_id: i.transcation_id || "",
        emd_created_proof: [],
        insurer_company: i.insurer_company || "",
        payee_name: i.payee_name || "",
        emd_type_multi: multi,
        cost_of_rfp: i.cost_of_rfp || "",
        cost_of_rfp_mode: i.cost_of_rfp_mode || "",
      });
    }
  }, [show]);

  const handleClose = () => {
    setShow(false);
    setRfpModeCustom("");
    setIsOtherMode(false);
    setFormData({
      bg_created: "",
      payer_bank: "",
      bg_creation_date: "",
      bg_expiry_date: "",
      ref_no: "",
      bg_created_on_behalf_of: "",
      bg_created_by: "",
      emd_type: "",
      bg_transcation_date: "",
      account_number: "",
      name_of_account_holder: "",
      transcation_id: "",
      emd_created_proof: [],
      insurer_company: "",
      payee_name: "",
      emd_type_multi: [],
      cost_of_rfp: "",
      cost_of_rfp_mode: "",


    });
  };

  const handleShow = () => {
    setShow(true);
  };

  // When user selects a type from dropdown:
  // - set emd_type to selected value (for UI/conditional fields)
  // - set emd_type_multi to [selected value] (single selection, replaces old multi)
  const handleEmdTypeChange = (e) => {
    const selected = e.target.value;
    setFormData((prev) => ({
      ...prev,
      emd_type: selected,
      emd_type_multi: selected ? [selected] : [],
    }));
    setInputState((prev) => ({ ...prev, emd_type: selected ? "green" : "" }));
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked, files } = e.target;

    let newValue;
    if (type === "checkbox") newValue = checked;
    else if (type === "file") newValue = Array.from(files);
    else newValue = value;

    const hasValue = Array.isArray(newValue) ? newValue.length > 0 : !!newValue;
    setInputState((prev) => ({ ...prev, [name]: hasValue ? "green" : "" }));
    setFormData((prev) => ({ ...prev, [name]: newValue }));
  };

  const validateForm = () => {
    const newErrors = {};

    const requiredFields = [
      formData.emd_type === "demand_draft" || formData.emd_type === "Bank_Gurantee"
        ? "bg_creation_date" : null,
      formData.emd_type === "demand_draft" || formData.emd_type === "Bank_Gurantee"
        ? "bg_expiry_date" : null,
      formData.emd_type === "demand_draft" || formData.emd_type === "Bank_Gurantee"
        ? "ref_no" : null,
      formData.emd_type === "neft" || formData.emd_type === "card"
        ? "bg_transcation_date" : null,
      formData.emd_type === "neft" || formData.emd_type === "card"
        ? "account_number" : null,
      formData.emd_type === "neft" || formData.emd_type === "card"
        ? "name_of_account_holder" : null,
      formData.emd_type === "suretybond" ? "insurer_company" : null,
      formData.emd_type === "suretybond" ? "ref_no" : null,
      formData.emd_type === "demand_draft" ? "payee_name" : null,
      formData.emd_type === "demand_draft" ? "account_number" : null,
      formData.emd_type !== "suretybond" ? "payer_bank" : null,
      "emd_type",
      "bg_created",
      "bg_created_by",
      "emd_created_proof",
    ].filter(Boolean);

    requiredFields.forEach((field) => {
      if (field === "emd_created_proof") {
        if (!formData.emd_created_proof || formData.emd_created_proof.length === 0) {
          newErrors[field] = "Emd Created Proof is required!";
        }
        return;
      }
      if (!formData[field]) {
        newErrors[field] = `${field
          .split("_")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ")} is required!`;
      }
    });

    // If RFP cost is entered, mode is required
    if (formData.cost_of_rfp && !formData.cost_of_rfp_mode) {
      newErrors.cost_of_rfp_mode = "RFP Cost Mode is required when RFP Cost is entered!";
    }

    // If "other" was selected, the custom text must be typed (cost_of_rfp_mode
    // holds the typed value directly — so if it's empty after choosing "other",
    // the user hasn't typed anything yet)
    const standardModes = ["online", "offline"];
    if (
      formData.cost_of_rfp &&
      formData.cost_of_rfp_mode &&
      !standardModes.includes(formData.cost_of_rfp_mode) &&
      formData.cost_of_rfp_mode.trim() === ""
    ) {
      newErrors.cost_of_rfp_mode = "Please specify the RFP Cost Mode!";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true);
    const loadingToastId = toast.loading("Updating BG details...");

    try {
      const formDataToSend = new FormData();
      formDataToSend.append("bg_created", true);

      // Append all fields except emd_type and emd_type_multi (handle separately)
      Object.keys(formData).forEach((key) => {
        if (key === "emd_type_multi" || key === "emd_type" || key === "emd_created_proof") return;
        formDataToSend.append(key, formData[key]);
      });

      // Append every file under the same field name
      if (Array.isArray(formData.emd_created_proof)) {
        formData.emd_created_proof.forEach((file) => {
          formDataToSend.append("emd_created_proof", file);
        });
      }

      // emd_type → only send a valid Django choice
      // if selected type is custom (e.g. "test"), send blank or first valid fallback
      const selectedType = formData.emd_type;
      const emdTypeToSend = validKeys.has(selectedType)
        ? selectedType
        : formData.emd_type_multi?.find((t) => validKeys.has(t)) || "";
      formDataToSend.append("emd_type", emdTypeToSend);

      // emd_type_multi → always send the selected value as a single-item array
      // so the record reflects exactly what user chose
      const emdTypeMultiToSend = formData.emd_type_multi?.length
        ? formData.emd_type_multi
        : selectedType
          ? [selectedType]
          : [];
      formDataToSend.append("emd_type_multi", JSON.stringify(emdTypeMultiToSend));

      if (toggleState === 1) {
        formDataToSend.append("is_in_created", true);
      }

      const res = await axios.put(
        `${BASE_URL}/siteproject/bgdetailsforbdput/${i.id}/`,
        formDataToSend,
        { headers: { "Content-Type": "multipart/form-data" } },
      );

      if (res.status === 200) {
        if (toggleState === 1) {
          try {
            await axios.put(
              `${BASE_URL}/siteproject/tenderforbdupdateemdtype/${i.tender_id}/`,
              {
                emd_type: emdTypeToSend,
                emd_type_multi: emdTypeMultiToSend,
                bgcreatedfor_tender: true,
              },
              { headers: { "Content-Type": "application/json" } },
            );
          } catch (err) {
            handleErrorToast(err);
          }
        }

        await getBgDetails();
        handleClose();
        toast.dismiss(loadingToastId);
        toast.success("Emd details updated successfully!");
      }
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setLoading(false);
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>
      <button
        title="Update BG Details"
        className="tender-card__action-secondary"
        onClick={handleShow}
      >
        Edit
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="request-leave large-modal"
        size="lg"
      >
        <Modal.Header
          closeButton
          className="justify-center task-Tab-heading font-weight500 font-size-heading"
        >
          <Modal.Title>Update Emd Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form className="register-from">
            <div className="form-flex-wrap">

              {/* BG Created */}
              <div className="flex-column">
                <label className="form-labels font-weight500 font-size-subheading">
                  Emd Created <span className="required">*</span>
                </label>
                <select
                  name="bg_created"
                  value={formData.bg_created}
                  onChange={handleInputChange}
                  className="form-input font-weight400 font-size-subheading form-input-background"
                >
                  <option value="">Select an option</option>
                  <option value={false}>No</option>
                  <option value={true}>Yes</option>
                </select>
                {errors.bg_created && (
                  <span className="error-message font-size-text">{errors.bg_created}</span>
                )}
              </div>

              {/* EMD Created By */}
              <div className="flex-column">
                <label className="form-labels font-weight500 font-size-subheading">
                  Emd Created By <span className="required">*</span>
                </label>
                <select
                  name="bg_created_by"
                  value={formData.bg_created_by}
                  onChange={handleInputChange}
                  className="form-input font-weight400 font-size-subheading form-input-background"
                >
                  <option value="">Select an option</option>
                  <option value="CIPL">CIPL</option>
                  <option value="SAPL">SAPL</option>
                </select>
                {errors.bg_created_by && (
                  <span className="error-message font-size-text">{errors.bg_created_by}</span>
                )}
              </div>

              {/* EMD Type — uses handleEmdTypeChange */}
              <div className="dropdown-wrapper flex justify-center">
                <label htmlFor="emd_type" className="form-labels font-weight500 font-size-subheading">
                  Emd Type <span className="required">*</span>
                </label>
                <br />
                <select
                  id="emd_type"
                  name="emd_type"
                  value={formData.emd_type}
                  onChange={handleEmdTypeChange}
                  className="form-input font-size-subheading"
                >
                  <option value="">EMD Type</option>
                  {EmdType.map((emd) => (
                    <option key={emd.key} value={emd.key}>{emd.value}</option>
                  ))}
                </select>
                {errors.emd_type && (
                  <span className="error-message font-size-text">{errors.emd_type}</span>
                )}
              </div>

              {/* Payer Bank */}
              {formData.emd_type !== "suretybond" && (
                <div className="flex-column">
                  <label className="form-labels font-weight500 font-size-subheading">
                    Payer Bank <span className="required">*</span>
                  </label>

                  <select
                    name="payer_bank"
                    value={formData.payer_bank}
                    onChange={handleInputChange}
                    className="form-input font-weight400 font-size-subheading form-input-background"
                  >
                    <option value="">Select an option</option>
                    <option value="Hdfc Bank">Hdfc Bank</option>
                    <option value="Yes Bank">Yes Bank</option>
                    <option value="Icici Bank">Icici Bank</option>
                  </select>

                  {errors.payer_bank && (
                    <span className="error-message font-size-text">
                      {errors.payer_bank}
                    </span>
                  )}
                </div>
              )}

              {/* DEMAND DRAFT fields */}
              {formData.emd_type === "demand_draft" && (
                <>
                  <div className="flex-column">
                    <label className="form-labels font-weight500 font-size-subheading">
                      Payee Name <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      name="payee_name"
                      placeholder="Enter payee name"
                      value={formData.payee_name}
                      onChange={handleInputChange}
                      className="form-input font-weight400 font-size-subheading form-input-background"
                    />
                    {errors.payee_name && (
                      <span className="error-message font-size-text">{errors.payee_name}</span>
                    )}
                  </div>
                  <div className="flex-column">
                    <label className="form-labels font-weight500 font-size-subheading">
                      Account Number <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      name="account_number"
                      placeholder="Enter account number"
                      value={formData.account_number}
                      onChange={handleInputChange}
                      className="form-input font-weight400 font-size-subheading form-input-background"
                    />
                    {errors.account_number && (
                      <span className="error-message font-size-text">{errors.account_number}</span>
                    )}
                  </div>
                </>
              )}

              {/* SURETY BOND fields */}
              {formData.emd_type === "suretybond" && (
                <>
                  <div className="flex-column">
                    <label className="form-labels font-weight500 font-size-subheading">
                      Insurer Company <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      name="insurer_company"
                      placeholder="Enter insurer company name"
                      value={formData.insurer_company}
                      onChange={handleInputChange}
                      className="form-input font-weight400 font-size-subheading form-input-background"
                    />
                    {errors.insurer_company && (
                      <span className="error-message font-size-text">{errors.insurer_company}</span>
                    )}
                  </div>
                </>
              )}

              {/* Creation Date / Transaction Date */}
              {formData.emd_type === "demand_draft" || formData.emd_type === "Bank_Gurantee" ? (
                <div className="flex-column">
                  <label className="form-labels font-weight500 font-size-subheading">
                    Emd Creation Date <span className="required">*</span>
                  </label>
                  <input
                    type="date"
                    name="bg_creation_date"
                    value={formData.bg_creation_date}
                    onChange={handleInputChange}
                    className="form-input font-weight400 font-size-subheading form-input-background"
                  />
                  {errors.bg_creation_date && (
                    <span className="error-message font-size-text">{errors.bg_creation_date}</span>
                  )}
                </div>
              ) : (
                formData.emd_type !== "suretybond" && (
                  <div className="flex-column">
                    <label className="form-labels font-weight500 font-size-subheading">
                      Emd Transaction Date <span className="required">*</span>
                    </label>
                    <input
                      type="date"
                      name="bg_transcation_date"
                      value={formData.bg_transcation_date}
                      onChange={handleInputChange}
                      className="form-input font-weight400 font-size-subheading form-input-background"
                    />
                    {errors.bg_transcation_date && (
                      <span className="error-message font-size-text">{errors.bg_transcation_date}</span>
                    )}
                  </div>
                )
              )}

              {/* Expiry Date */}
              {(formData.emd_type === "demand_draft" || formData.emd_type === "Bank_Gurantee") && (
                <div className="flex-column">
                  <label className="form-labels font-weight500 font-size-subheading">
                    Emd Expiry Date <span className="required">*</span>
                  </label>
                  <input
                    type="date"
                    name="bg_expiry_date"
                    value={formData.bg_expiry_date}
                    onChange={handleInputChange}
                    className="form-input font-weight400 font-size-subheading form-input-background"
                    min={formData.bg_creation_date}
                  />
                  {errors.bg_expiry_date && (
                    <span className="error-message font-size-text">{errors.bg_expiry_date}</span>
                  )}
                </div>
              )}

              {/* NEFT / Card fields */}
              {(formData.emd_type === "neft" || formData.emd_type === "card") && (
                <>
                  <div className="flex-column">
                    <label className="form-labels font-weight500 font-size-subheading">
                      Account Number/Card Number <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      name="account_number"
                      placeholder="Enter Account/Card number"
                      value={formData.account_number}
                      onChange={handleInputChange}
                      className="form-input font-weight400 font-size-subheading form-input-background"
                    />
                    {errors.account_number && (
                      <span className="error-message font-size-text">{errors.account_number}</span>
                    )}
                  </div>
                  <div className="flex-column">
                    <label className="form-labels font-weight500 font-size-subheading">
                      Name of Account/Card Holder <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      name="name_of_account_holder"
                      placeholder="Name of Account/Card Holder"
                      value={formData.name_of_account_holder}
                      onChange={handleInputChange}
                      className="form-input font-weight400 font-size-subheading form-input-background"
                    />
                    {errors.name_of_account_holder && (
                      <span className="error-message font-size-text">{errors.name_of_account_holder}</span>
                    )}
                  </div>
                  <div className="flex-column">
                    <label className="form-labels font-weight500 font-size-subheading">
                      Transaction Id
                    </label>
                    <input
                      type="text"
                      name="transcation_id"
                      placeholder="Transaction Id"
                      value={formData.transcation_id}
                      onChange={handleInputChange}
                      className="form-input font-weight400 font-size-subheading form-input-background"
                    />
                  </div>
                </>
              )}

              {/* Reference No for DD / BG */}
              {(formData.emd_type === "demand_draft" || formData.emd_type === "Bank_Gurantee" || formData.emd_type === "suretybond") && (
                <div className="flex-column">
                  <label className="form-labels font-weight500 font-size-subheading">
                    Reference No <span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    name="ref_no"
                    placeholder="Enter reference number"
                    value={formData.ref_no}
                    onChange={handleInputChange}
                    className="form-input font-weight400 font-size-subheading form-input-background"
                  />
                  {errors.ref_no && (
                    <span className="error-message font-size-text">{errors.ref_no}</span>
                  )}
                </div>
              )}

              {/* On Behalf Of */}
              <div className="flex-column">
                <label className="form-labels font-weight500 font-size-subheading">
                  Emd Created On Behalf Of:
                </label>
                <select
                  name="bg_created_on_behalf_of"
                  value={formData.bg_created_on_behalf_of}
                  onChange={handleInputChange}
                  className="form-input font-weight400 font-size-subheading form-input-background"
                >
                  <option value="">Select an option</option>
                  {i.lead_partner && <option value={i.lead_partner}>{i.lead_partner}</option>}
                  {i.assosiate_partner && <option value={i.assosiate_partner}>{i.assosiate_partner}</option>}
                  {i.jv_partner_name && <option value={i.jv_partner_name}>{i.jv_partner_name}</option>}
                </select>
              </div>
              {/* RFP Cost */}
              <div className="flex-column">
                <label className="form-labels font-weight500 font-size-subheading">
                  RFP Cost
                </label>
                <input
                  type="number"
                  name="cost_of_rfp"
                  placeholder="Enter full amount (e.g. 1 crore = 10000000)"
                  value={formData.cost_of_rfp}
                  onChange={handleInputChange}
                  className={`form-input font-weight400 font-size-subheading form-input-background ${errors.cost_of_rfp ? "error" : inputState.cost_of_rfp ? "success" : ""
                    }`}
                />
                {errors.cost_of_rfp && (
                  <span className="error-message font-size-text">{errors.cost_of_rfp}</span>
                )}
              </div>

              {/* RFP Cost Mode */}
              <div className="flex-column">
                <label className="form-labels font-weight500 font-size-subheading">
                  RFP Cost Mode
                </label>
                <select
                  name="cost_of_rfp_mode"
                  value={
                    formData.cost_of_rfp_mode === "online" || formData.cost_of_rfp_mode === "offline"
                      ? formData.cost_of_rfp_mode
                      : isOtherMode
                        ? "other"
                        : ""
                  }
                  onChange={(e) => {
                    const val = e.target.value;
                    if (val === "other") {
                      setIsOtherMode(true);
                      setRfpModeCustom("");
                      setFormData((prev) => ({ ...prev, cost_of_rfp_mode: "" }));
                    } else {
                      setIsOtherMode(false);
                      setRfpModeCustom("");
                      setFormData((prev) => ({ ...prev, cost_of_rfp_mode: val }));
                    }
                  }}
                  className={`form-input font-weight400 font-size-subheading form-input-background ${errors.cost_of_rfp_mode ? "error" : inputState.cost_of_rfp_mode ? "success" : ""
                    }`}
                >
                  <option value="">Select RFP Cost Mode</option>
                  <option value="online">Online</option>
                  <option value="offline">Offline</option>
                  <option value="other">Other</option>
                </select>
                {errors.cost_of_rfp_mode && (
                  <span className="error-message font-size-text">{errors.cost_of_rfp_mode}</span>
                )}
              </div>



              {/* Simpler condition: show if dropdown is on "other" (cost_of_rfp_mode is not a standard value and select shows "other") */}
              {isOtherMode && (
                <div className="flex-column">
                  <label className="form-labels font-weight500 font-size-subheading">
                    Specify RFP Cost Mode <span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="e.g. Challan, DD, Cheque"
                    value={rfpModeCustom}
                    onChange={(e) => {
                      setRfpModeCustom(e.target.value);
                      // write typed value directly into cost_of_rfp_mode → sent to backend
                      setFormData((prev) => ({ ...prev, cost_of_rfp_mode: e.target.value }));
                    }}
                    className={`form-input font-weight400 font-size-subheading form-input-background ${errors.cost_of_rfp_mode ? "error" : ""
                      }`}
                  />
                  {errors.cost_of_rfp_mode && (
                    <span className="error-message font-size-text">{errors.cost_of_rfp_mode}</span>
                  )}
                </div>
              )}

              {/* Upload Proof */}
              <div style={{ width: "100%" }}>
                <div style={{ width: "100%", maxWidth: 480, margin: "0", background: "#fff", borderRadius: 8, boxShadow: "0 2px 12px #eee", padding: 32 }}>
                  <label
                    className="form-labels font-weight500 font-size-subheading"
                    style={{ marginBottom: 12, display: "block", fontSize: 18, fontWeight: 600 }}
                  >
                    Upload Emd Created Proof <span className="required">*</span>
                  </label>
                  <input
                    type="file"
                    name="emd_created_proof"
                    multiple
                    onChange={handleInputChange}
                    style={{ marginBottom: 8, width: "100%" }}
                    className="form-control"
                  />
                  {formData.emd_created_proof.length > 0 && (
                    <ul style={{ marginBottom: 16, paddingLeft: 18 }}>
                      {formData.emd_created_proof.map((file, idx) => (
                        <li key={idx} style={{ fontSize: 13 }}>
                          {file.name}
                          <button
                            type="button"
                            onClick={() =>
                              setFormData((prev) => ({
                                ...prev,
                                emd_created_proof: prev.emd_created_proof.filter((_, i) => i !== idx),
                              }))
                            }
                            style={{ marginLeft: 8, color: "red", border: "none", background: "none", cursor: "pointer" }}
                          >
                            ✕
                          </button>
                        </li>
                      ))}
                    </ul>
                  )}
                  {errors.emd_created_proof && (
                    <span className="error-message font-size-text">{errors.emd_created_proof}</span>
                  )}
                </div>
              </div>

            </div>
          </form>

          <div className="button-models">
            <button className="model-button font-weight500 model-button-cancel" onClick={handleClose}>
              Cancel
            </button>
            <button
              type="submit"
              className="model-button font-weight500 model-button-leave font-size-heading"
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading ? "Updating..." : "Update"}
            </button>
          </div>

          <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </Modal.Body>
      </Modal>
    </>
  );
};

// ! *************** Addtocart Component ***************

// ! *************** Move To Next Stage Component (replaces Addtocart + MoveToRealisedEmd) ***************
const STAGE_TARGET_MAP = {
  1: { field: "is_in_created", label: "Created Emd" },
  2: { field: "is_submitted", label: "Submitted Emd" },
  3: { field: "is_matured", label: "Matured Emd" },
  4: { field: "is_released", label: "Released Emd" },
};
// ! *************** Release-stage field requirements, by EMD type ***************
// Mirrors the type-specific fields captured on creation (UpdateBgDetails),
// but for what's needed to confirm the EMD was actually *received back*.
const RELEASE_EMD_TYPE_OPTIONS = [
  { key: "neft", label: "NEFT", field: "utr_number", fieldLabel: "UTR Number" },
  { key: "demand_draft", label: "Demand Draft", field: "dd_number", fieldLabel: "DD Number" },
  { key: "Bank_Gurantee", label: "Bank Guarantee", field: "bg_number", fieldLabel: "BG Number" },
  { key: "suretybond", label: "Surety Bond", field: "bond_number", fieldLabel: "Surety Bond Number" },
  { key: "fdr", label: "FDR", field: "fd_number", fieldLabel: "FD Number" },
  { key: "other", label: "Other", field: "other_emd_type_number", fieldLabel: "Other EMD Number" },
];

const getReleaseEmdTypeOption = (key) =>
  RELEASE_EMD_TYPE_OPTIONS.find((o) => o.key === key) || null;

// Uploads release proof files up front and returns the {id, file, uploaded_at}
// refs the backend expects inside released_emd_details[].attachments.
// NOTE: adjust the path prefix if your axios instance / BASE_URL already
// includes "/api" — wired here exactly as given: /api/bgdetailsforbd/upload-release-attachments/<pk>/
const uploadReleaseAttachments = async (tenderPk, files) => {
  if (!files || files.length === 0) return [];
  const fd = new FormData();
  files.forEach((f) => fd.append("attachments", f));
  const res = await axios.post(
    `${BASE_URL}/siteproject/bgdetailsforbd/upload-release-attachments/${tenderPk}/`,
    fd,
    { headers: { "Content-Type": "multipart/form-data" } },
  );
  return res.data;
};

const EMD_TYPE_OPTIONS = [
  { key: "Bank_Gurantee", value: "Bank Guarantee" },
  { key: "neft", value: "NEFT" },
  { key: "demand_draft", value: "Demand Draft" },
  { key: "suretybond", value: "Surety Bond" },
  { key: "card", value: "Card" },
];

const formatEmdTypeLabel = (type) => {
  if (!type) return "";
  const found =
    RELEASE_EMD_TYPE_OPTIONS.find((o) => o.key === type) ||
    EMD_TYPE_OPTIONS.find((o) => o.key === type);
  if (found) return found.label || found.value;
  return type.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
};

// The reference captured at EMD *creation* — shown read-only in the release
// modal so the user can visually match it. Never re-entered.
const getCreationRefDisplay = (item) => {
  const type = item?.emd_type_multi?.[0] || item?.emd_type;
  if (!type) return null;
  if (type === "neft" || type === "card") {
    return item.transcation_id
      ? { label: "Transaction Id", value: item.transcation_id }
      : null;
  }
  if (type === "demand_draft" || type === "Bank_Gurantee" || type === "suretybond") {
    const opt = getReleaseEmdTypeOption(type);
    return item.ref_no
      ? { label: opt?.fieldLabel || "Reference No", value: item.ref_no }
      : null;
  }
  return null;
};
const MoveToNextStage = ({ i, getBgDetails, toggleState }) => {
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [uploading, setUploading] = useState(false);

  const [releaseDate, setReleaseDate] = useState("");
  const [utrNumber, setUtrNumber] = useState("");
  const [releaseRemarks, setReleaseRemarks] = useState("");
  const [releaseFiles, setReleaseFiles] = useState([]);
  const [errors, setErrors] = useState({});

  const target = STAGE_TARGET_MAP[toggleState];
  if (!target) return null;

  const isReleaseMove = toggleState === 4;
  // EMD type is prefilled from what was captured at creation — never re-asked.
  const prefillEmdType = i.emd_type_multi?.[0] || i.emd_type || "";
  const creationRef = getCreationRefDisplay(i);

  const handleClose = () => {
    setShow(false);
    setReleaseDate("");
    setUtrNumber("");
    setReleaseRemarks("");
    setReleaseFiles([]);
    setErrors({});
  };
  const handleShow = () => setShow(true);

  const validate = () => {
    if (!isReleaseMove) return true;
    const newErrors = {};
    if (!releaseDate) newErrors.release_date = "EMD Receiving Date is required!";
    if (prefillEmdType === "neft" && !utrNumber.trim()) {
      newErrors.utr_number = "UTR Number is required!";
    }
    if (releaseFiles.length === 0) newErrors.release_files = "Proof attachment is required!";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleConfirm = async () => {
    if (!validate()) return;
    setLoading(true);
    const loadingToastId = toast.loading("Updating...");

    try {
      if (isReleaseMove) {
        let attachments = [];
        if (releaseFiles.length > 0) {
          setUploading(true);
          attachments = await uploadReleaseAttachments(i.id, releaseFiles);
          setUploading(false);
        }

        const releasedEmdDetail = {
          emd_type: prefillEmdType,
          emd_receiving_date: releaseDate,
          remarks: releaseRemarks,
          ...(prefillEmdType === "neft" ? { utr_number: utrNumber } : {}),
          attachments: attachments.map((a) => ({ id: a.id, file: a.file })),
        };

        await axios.put(
          `${BASE_URL}/siteproject/bgdetailsforbdput/${i.id}/`,
          {
            [target.field]: true,
            released_emd_details: [releasedEmdDetail],
          },
          { headers: { "Content-Type": "application/json" } },
        );
      } else {
        await axios.put(
          `${BASE_URL}/siteproject/bgdetailsforbdput/${i.id}/`,
          { [target.field]: true },
          { headers: { "Content-Type": "application/json" } },
        );
      }

      await getBgDetails();
      setShow(false);
      toast.success(`Moved to ${target.label}`);
      handleClose();
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setLoading(false);
      setUploading(false);
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>
      <button
        title="Move To Next"
        onClick={handleShow}
        className="tender-card__action-outline"
        style={{ padding: "0px 10px", height: "28px" }}
      >
        →
      </button>

      <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
        <Modal.Header closeButton>
          <Modal.Title>Move Tender To {target.label}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="parent-div">
            Are you sure you want to move this tender ({i.tender_name || i.tender_id}) to {target.label}?

            {isReleaseMove && (
              <div className="form-flex-wrap" style={{ marginTop: 12 }}>
                <div className="flex-column">
                  <label className="form-labels font-weight500 font-size-subheading">
                    EMD Receiving Date <span className="required">*</span>
                  </label>
                  <input
                    type="date"
                    value={releaseDate}
                    onChange={(e) => setReleaseDate(e.target.value)}
                    className="form-input font-weight400 font-size-subheading form-input-background"
                  />
                  {errors.release_date && (
                    <span className="error-message font-size-text">{errors.release_date}</span>
                  )}
                </div>

                <div className="flex-column">
                  <label className="form-labels font-weight500 font-size-subheading">EMD Type</label>
                  <input
                    type="text"
                    readOnly
                    disabled
                    value={formatEmdTypeLabel(prefillEmdType) || "-"}
                    className="form-input font-weight400 font-size-subheading form-input-background"
                    style={{ background: "#f6f8fa" }}
                  />
                </div>

                {creationRef && (
                  <div className="flex-column">
                    <label className="form-labels font-weight500 font-size-subheading">
                      {creationRef.label} (on record)
                    </label>
                    <input
                      type="text"
                      readOnly
                      disabled
                      value={creationRef.value}
                      className="form-input font-weight400 font-size-subheading form-input-background"
                      style={{ background: "#f6f8fa", color: "#57606a" }}
                      title="Captured at EMD creation — for matching only"
                    />
                  </div>
                )}

                {prefillEmdType === "neft" && (
                  <div className="flex-column">
                    <label className="form-labels font-weight500 font-size-subheading">
                      UTR Number <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      value={utrNumber}
                      onChange={(e) => setUtrNumber(e.target.value)}
                      className="form-input font-weight400 font-size-subheading form-input-background"
                      placeholder="Enter UTR Number"
                    />
                    {errors.utr_number && (
                      <span className="error-message font-size-text">{errors.utr_number}</span>
                    )}
                  </div>
                )}

                <div className="flex-column" style={{ flex: 1, minWidth: 220 }}>
                  <label className="form-labels font-weight500 font-size-subheading">Remarks</label>
                  <input
                    type="text"
                    value={releaseRemarks}
                    onChange={(e) => setReleaseRemarks(e.target.value)}
                    className="form-input font-weight400 font-size-subheading form-input-background"
                    placeholder="Optional"
                  />
                </div>

                <div className="flex-column" style={{ width: "100%" }}>
                  <label className="form-labels font-weight500 font-size-subheading">
                    Proof <span className="required">*</span>
                  </label>
                  <input
                    type="file"
                    multiple
                    onChange={(e) =>
                      setReleaseFiles((prev) => [...prev, ...Array.from(e.target.files || [])])
                    }
                    className="form-control"
                  />
                  {releaseFiles.length > 0 && (
                    <ul style={{ marginTop: 8, paddingLeft: 18 }}>
                      {releaseFiles.map((file, idx) => (
                        <li key={idx} style={{ fontSize: 12 }}>
                          {file.name}
                          <button
                            type="button"
                            onClick={() => setReleaseFiles((prev) => prev.filter((_, fi) => fi !== idx))}
                            style={{ marginLeft: 8, color: "red", border: "none", background: "none", cursor: "pointer" }}
                          >
                            ✕
                          </button>
                        </li>
                      ))}
                    </ul>
                  )}
                  {errors.release_files && (
                    <span className="error-message font-size-text">{errors.release_files}</span>
                  )}
                  {uploading && (
                    <span style={{ fontSize: 12, color: "#57606a" }}>Uploading attachments...</span>
                  )}
                </div>
              </div>
            )}

            <div className="button-models">
              <button className="model-button model-button-cancel" onClick={handleClose}>
                Cancel
              </button>
              <button
                onClick={handleConfirm}
                className="model-button model-button-delete"
                disabled={loading || uploading}
              >
                {uploading ? "Uploading..." : loading ? "Updating..." : "Confirm"}
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

// ! *************** Upload BG Old Component ***************
const UploadBgOld = ({ getBgOldData }) => {
  const [show, setShow] = useState(false);
  const [fileName, setFileName] = useState("");
  const [excelJson, setExcelJson] = useState(null);
  const [docErrors, setDocErrors] = useState({});
  const [docInputState, setDocInputState] = useState({});

  const bulktableRef = useRef(null);
  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = "/bg_format.xlsx";
    link.setAttribute("download", "Bg_Details.xlsx");
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  const handleClose = () => {
    setFileName("");
    setExcelJson(null);
    setDocErrors({});
    setShow(false);
  };
  const handleShow = () => setShow(true);

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    setDocErrors({});
    if (file) {
      const validFileTypes = [
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-excel",
      ];
      if (!validFileTypes.includes(file.type)) {
        setDocErrors({
          document_file: "Please upload a valid Excel file (.xlsx or .xls).",
        });
        setFileName("");
        return;
      }

      setFileName(file.name);
      readExcel(file);
    } else {
      setFileName("");
    }
  };

  const formatDisplayDate = (dateStr) => {
    if (!dateStr) return "";
    const parts = dateStr.split("-");
    if (parts.length === 3) {
      return `${parts[2]}-${parts[1]}-${parts[0]}`;
    }
    return dateStr;
  };

  const readExcel = (file) => {
    const reader = new FileReader();

    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      const sheetData = XLSX.utils.sheet_to_json(worksheet, {
        header: 1,
        defval: null,
      });

      const fields = [
        "project_name",
        "project_name_in_detail",
        "bg",
        "work_type",
        "lead_firm",
        "jv",
        "association_firm",
        "on_behalf_of",
        "type",
        "type_of_security",
        "bank_gurentee_no",
        "bank_gurentee_issue_date",
        "bg_expiry_date",
        "claim_period",
        "benificiary_name",
        "bg_amount",
        "fd_number",
        "margin",
        "submitted_to_bd_dept",
        "submitted_date",
        "person_name",
        "bank_name",
        "company_name",
        "limit",
        "sfms",
        "responsibility",
      ];

      const convertToYYYYMMDD = (input) => {
        try {
          if (!input) return null;
          let date;

          if (typeof input === "number") {
            const excelEpoch = new Date(1899, 11, 30);
            date = new Date(excelEpoch.getTime() + input * 86400000);
          } else if (typeof input === "string") {
            let normalized = input.trim().replace(/[\.\s/]+/g, "-");

            if (/^\d{1,2}-\d{1,2}-\d{4}$/.test(normalized)) {
              const [d, m, y] = normalized.split("-");
              date = new Date(
                `${y}-${m.padStart(2, "0")}-${d.padStart(2, "0")}`,
              );
            } else if (/^\d{4}-\d{1,2}-\d{1,2}$/.test(normalized)) {
              const [y, m, d] = normalized.split("-");
              date = new Date(
                `${y}-${m.padStart(2, "0")}-${d.padStart(2, "0")}`,
              );
            } else {
              date = new Date(normalized);
            }
          } else {
            date = new Date(input);
          }

          if (isNaN(date.getTime())) return null;
          return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
        } catch {
          return null;
        }
      };

      const normalize = (str) =>
        str
          ?.toString()
          .replace(/[\n\r\t]/g, "")
          .replace(/\s+/g, " ")
          .trim()
          .toLowerCase();

      const headerRowIndex = sheetData.findIndex((row) => {
        if (!Array.isArray(row)) return false;
        const normalizedRow = row.map(normalize);
        return fields.every((field) =>
          normalizedRow.includes(normalize(field)),
        );
      });

      if (headerRowIndex === -1) {
        toast.error("❌ Correct header row not found in Excel sheet.");
        return;
      }

      const headers = sheetData[headerRowIndex];
      const dataRows = sheetData.slice(headerRowIndex + 1);

      const formattedJson = dataRows.map((row) => {
        const obj = {};
        headers.forEach((header, idx) => {
          if (fields.includes(header)) {
            const val = row[idx];
            if (
              [
                "bank_gurentee_issue_date",
                "bg_expiry_date",
                "claim_period",
                "submitted_date",
              ].includes(header)
            ) {
              obj[header] = convertToYYYYMMDD(val);
            } else if (typeof val === "string") {
              obj[header] = val.trim();
            } else {
              obj[header] = val ?? null;
            }
          }
        });
        return obj;
      });

      const nonEmptyRows = formattedJson.filter((row) =>
        Object.values(row).some((val) => val !== null && val !== ""),
      );

      setExcelJson(nonEmptyRows);
    };

    reader.readAsArrayBuffer(file);
  };

  const [validationErrors, setValidationErrors] = useState([]);

  const handleUpload = async () => {
    if (!excelJson) {
      setDocErrors({ document_file: "Please upload a valid Excel file." });
      return;
    }

    const errors = [];

    excelJson?.forEach((row, i) => {
      if (!row.project_name) errors.push(`Row ${i + 2}: Project Name required`);
      if (!row.bank_gurentee_no)
        errors.push(`Row ${i + 2}: BG Number required`);
      if (!row.bg_amount) errors.push(`Row ${i + 2}: Amount required`);
    });

    if (errors.length > 0) {
      setValidationErrors(errors);
      return;
    }

    setValidationErrors([]);

    const loadingToastId = toast.loading("Uploading: Please wait...");

    try {
      const res = await axios.post(
        `${BASE_URL}/siteproject/bgdetailsforbdold/`,
        excelJson,
      );
      if (res.status === 200 || res.status === 201) {
        await getBgOldData();
        handleClose();
        toast.dismiss(loadingToastId);
        toast.success("Bg uploaded successfully.");
      } else {
        toast.dismiss(loadingToastId);
        toast.error("Failed to add data!");
      }
    } catch (err) {
      handleErrorToast(err);
    } finally {
      toast.dismiss(loadingToastId);
    }
  };

  const fields = [
    "project_name",
    "project_name_in_detail",
    "bg",
    "work_type",
    "lead_firm",
    "jv",
    "association_firm",
    "on_behalf_of",
    "type",
    "type_of_security",
    "bank_gurentee_no",
    "bank_gurentee_issue_date",
    "bg_expiry_date",
    "claim_period",
    "benificiary_name",
    "bg_amount",
    "fd_number",
    "margin",
    "submitted_to_bd_dept",
    "submitted_date",
    "person_name",
    "bank_name",
    "company_name",
    "limit",
    "sfms",
    "responsibility",
  ];
  const dateFields = [
    "bank_gurentee_issue_date",
    "bg_expiry_date",
    "claim_period",
    "submitted_date",
  ];

  const toTitleCase = (str) =>
    str.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());

  return (
    <>
      <button
        title="Upload"
        className="model-button   font-weight500   model-button-print"
        onClick={handleShow}
        style={{ margin: "2px" }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="22"
          id="upload"
        >
          <g
            fill="none"
            fillRule="evenodd"
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          >
            <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M14 5l-4-4-4 4M10 1v14"></path>
          </g>
        </svg>
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="ourcompany-model"
      >
        <Modal.Header
          closeButton
          className="justify-center task-Tab-heading font-weight500    font-size-heading "
        >
          <Modal.Title>Upload Bulk Bg Data in format :</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="flex-row align-center">
            <button
              onClick={handleDownload}
              className="model-button-download model-button font-weight500"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="22"
                id="download"
                fill="#fff"
              >
                <g
                  fill="none"
                  stroke="#fff"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                >
                  <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M6 11l4 4 4-4M10 1v14"></path>
                </g>
              </svg>
              {"  "} Format
            </button>
          </div>

          <div
            className="table-css-white-background"
            style={{ display: "none" }}
          >
            <table ref={bulktableRef} className="nested-table-lightblue">
              <thead>
                <tr className="custom-table-head-tr">
                  {fields.map((field, index) => (
                    <th key={index}>{field}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {excelJson?.map((project, rowIndex) => (
                  <tr key={rowIndex}>
                    {fields.map((field, colIndex) => (
                      <td key={colIndex}>
                        {typeof project[field] === "boolean"
                          ? project[field]
                            ? "Yes"
                            : "No"
                          : dateFields.includes(field) && project[field]
                            ? project[field]
                            : project[field]}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="table-css-white-background scroll-container">
            <div
              className="table-container scrollbar"
              style={{ width: "100%" }}
            >
              <table
                className="nested-table-lightblue"
                style={{ margin: "0px" }}
              >
                <thead className="table-heading">
                  <tr className="custom-table-head-tr">
                    {fields.map((field, index) => (
                      <th key={index} className="table-heading-text">
                        {toTitleCase(field)}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {excelJson?.map((project, rowIndex) => (
                    <tr key={rowIndex} className="modal-padding-heading">
                      {fields.map((field, colIndex) => (
                        <td key={colIndex} className="table-heading-text">
                          {typeof project[field] === "boolean"
                            ? project[field]
                              ? "Yes"
                              : "No"
                            : dateFields.includes(field) && project[field]
                              ? formatDisplayDate(project[field])
                              : project[field]}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div className="flex-column field-cont-div">
            <label
              htmlFor="document_file"
              className="form-labels announce-date font-weight500 font-size-heading"
            >
              Upload File
            </label>
            <label
              htmlFor="document_file"
              className={`align-center form-inputss custom-file-upload ${docErrors.document_file
                ? "error"
                : docInputState.document_file
                  ? "success"
                  : ""
                }`}
            >
              <svg
                className="pdf-input"
                xmlns="http://www.w3.org/2000/svg"
                width="15"
                height="15"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M17.8666 9.2081L10.2082 16.8664C9.27005 17.8046 7.99757 18.3317 6.67075 18.3317C5.34393 18.3317 4.07145 17.8046 3.13325 16.8664C2.19505 15.9282 1.66797 14.6558 1.66797 13.3289C1.66797 12.0021 2.19505 10.7296 3.13325 9.79144L10.7916 2.1331C11.4171 1.50763 12.2654 1.15625 13.1499 1.15625C14.0345 1.15625 14.8828 1.50763 15.5082 2.1331C16.1337 2.75857 16.4851 3.60689 16.4851 4.49144C16.4851 5.37598 16.1337 6.2243 15.5082 6.84977L7.84158 14.5081C7.52885 14.8208 7.10469 14.9965 6.66242 14.9965C6.22014 14.9965 5.79598 14.8208 5.48325 14.5081C5.17051 14.1954 4.99482 13.7712 4.99482 13.3289C4.99482 12.8867 5.17051 12.4625 5.48325 12.1498L12.5582 5.0831"
                  stroke="#707070"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </label>
            <input
              id="document_file"
              name="document_file"
              type="file"
              accept=".xlsx, .xls"
              onChange={handleFileChange}
              className="file-inputs align-center"
              style={{ display: "none", position: "relative" }}
            />
            {fileName && <p className="file-name align-center">{fileName}</p>}
            <br />
            {docErrors.document_file && (
              <span className="file-name error-message font-size-text ">
                {docErrors.document_file}
              </span>
            )}
          </div>

          <div className="button-models">
            <button
              className="model-button-cancel model-button font-weight500"
              onClick={handleClose}
            >
              Cancel
            </button>
            <button
              className="model-button-download model-button font-weight500"
              onClick={handleUpload}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="22"
                id="upload"
              >
                <g
                  fill="none"
                  stroke="#fff"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                >
                  <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M14 5l-4-4-4 4M10 1v14"></path>
                </g>
              </svg>
              {"  "} Upload
            </button>
          </div>
          {validationErrors.length > 0 && (
            <div
              style={{
                background: "#ffecec",
                border: "1px solid #f5c2c7",
                color: "#842029",
                borderRadius: "6px",
                padding: "10px",
                marginTop: "15px",
                fontSize: "14px",
                maxHeight: "200px",
                overflowY: "auto",
              }}
            >
              <strong>Validation Errors:</strong>
              <ul style={{ marginTop: "5px", paddingLeft: "20px" }}>
                {validationErrors.map((err, i) => (
                  <li key={i}>{err}</li>
                ))}
              </ul>
            </div>
          )}

          <h4 style={{ marginBottom: "1rem" }}>References:</h4>
        </Modal.Body>
        <ToastContainer
          position="top-center"
          autoClose={1000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </Modal>
    </>
  );
};
// ! *************** EMD Amendment Modal Component ***************
const EmdAmendmentModal = ({ item, getBgDetails }) => {
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [amendmentType, setAmendmentType] = useState(""); // "tenure" | "other"
  const [changes, setChanges] = useState([]);
  const [remarks, setRemarks] = useState("");
  const [amendedBy, setAmendedBy] = useState(sessionStorage.getItem("employee_name") || "");
  const [attachments, setAttachments] = useState([]);
  const [errors, setErrors] = useState({});

  const dateFieldKeys = [
    "submission_date",
    "corrigendum_date",
    "bg_expiry_date",
    "bg_creation_date",
    "bg_transcation_date",
    "due_date",
  ];

  const getCurrentValue = (fieldKey) => {
    if (!fieldKey || item[fieldKey] === undefined || item[fieldKey] === null || item[fieldKey] === "") return "-";
    const raw = item[fieldKey];
    if (dateFieldKeys.includes(fieldKey)) {
      return new Date(raw).toLocaleDateString("en-IN", { day: "2-digit", month: "2-digit", year: "numeric" });
    }
    return String(raw);
  };

  // Raw value for prefilling <input type="date"> (needs YYYY-MM-DD, not the en-IN display format)
  const getCurrentDateInputValue = (fieldKey) => (item[fieldKey] ? item[fieldKey].split("T")[0] : "");

  const handleClose = () => {
    setShow(false);
    setAmendmentType("");
    setChanges([]);
    setRemarks("");
    setAttachments([]);
    setErrors({});
  };
  const handleShow = () => setShow(true);

  const handleAmendmentTypeChange = (type) => {
    setAmendmentType(type);
    setErrors({});
    if (type === "tenure") {
      setChanges([
        {
          field: "bg_creation_date",
          label: "EMD Creation Date",
          prev_value: getCurrentValue("bg_creation_date"),
          new_value: getCurrentDateInputValue("bg_creation_date"),
        },
        {
          field: "bg_expiry_date",
          label: "EMD Expiry Date",
          prev_value: getCurrentValue("bg_expiry_date"),
          new_value: getCurrentDateInputValue("bg_expiry_date"),
        },
      ]);
    } else {
      setChanges([{ field: "", label: "", prev_value: "", new_value: "" }]);
    }
  };

  const handleTenureDateChange = (idx, value) => {
    setChanges((prev) => prev.map((c, i) => (i === idx ? { ...c, new_value: value } : c)));
  };

  const handleOtherFieldName = (value) => {
    setChanges((prev) => prev.map((c, i) => (i === 0 ? { ...c, field: value, label: value } : c)));
  };

  const handleOtherNewValue = (value) => {
    setChanges((prev) => prev.map((c, i) => (i === 0 ? { ...c, new_value: value } : c)));
  };

  const validate = () => {
    const newErrors = {};
    if (!amendmentType) newErrors.amendment_type = "Please select an amendment type!";
    if (!amendedBy.trim()) newErrors.amended_by = "Amended By is required!";
    if (!remarks.trim()) newErrors.remarks = "Remarks is required!";

    let validChanges = [];
    if (amendmentType === "tenure") {
      validChanges = changes.filter((c) => c.new_value && c.new_value.trim());
      if (validChanges.length === 0) newErrors.changes = "Please set at least one new date!";
    } else if (amendmentType === "other") {
      const c = changes[0] || {};
      if (!c.field?.trim() || !c.new_value?.trim()) {
        newErrors.changes = "Field name and new value are both required!";
      } else {
        validChanges = [c];
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0 ? validChanges : null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validChanges = validate();
    if (!validChanges) return;

    setLoading(true);
    const loadingToastId = toast.loading("Submitting amendment...");

    try {
      const formDataToSend = new FormData();
      formDataToSend.append("tender_id", item.id);
      formDataToSend.append(
        "changes",
        JSON.stringify(
          validChanges.map((c) => ({
            field: c.field,
            label: c.label || c.field,
            previous_value: c.prev_value && c.prev_value !== "-" ? c.prev_value : undefined,
            new_value: c.new_value,
          })),
        ),
      );
      formDataToSend.append("remarks", remarks);
      formDataToSend.append("amended_by", amendedBy);
      attachments.forEach((file) => formDataToSend.append("attachments", file));

      const res = await axios.post(
        `${BASE_URL}/siteproject/emdamendmentcreate/`,
        formDataToSend,
        { headers: { "Content-Type": "multipart/form-data" } },
      );

      if (res.status === 200 || res.status === 201) {
        toast.dismiss(loadingToastId);
        toast.success("Amendment recorded successfully!");
        await getBgDetails?.();
        handleClose();
      }
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setLoading(false);
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>
      <button
        title="Amendment Details"
        className="tender-card__action-secondary"
        onClick={handleShow}
      >
        Amendment
      </button>

      <Modal show={show} onHide={handleClose} dialogClassName="request-leave large-modal" size="lg">
        <Modal.Header closeButton className="justify-center task-Tab-heading font-weight500 font-size-heading">
          <Modal.Title>EMD Amendment — {item.tender_name || item.tender_id}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form className="register-from">
            <div className="flex-column" style={{ marginBottom: 12 }}>
              <label className="form-labels font-weight500 font-size-subheading">
                Amendment Type <span className="required">*</span>
              </label>
              <div style={{ display: "flex", gap: 20 }}>
                <label style={{ display: "flex", alignItems: "center", gap: 6, fontWeight: 400, cursor: "pointer" }}>
                  <input
                    type="radio"
                    name="amendmentType"
                    checked={amendmentType === "tenure"}
                    onChange={() => handleAmendmentTypeChange("tenure")}
                  />
                  Tenure
                </label>
                <label style={{ display: "flex", alignItems: "center", gap: 6, fontWeight: 400, cursor: "pointer" }}>
                  <input
                    type="radio"
                    name="amendmentType"
                    checked={amendmentType === "other"}
                    onChange={() => handleAmendmentTypeChange("other")}
                  />
                  Other
                </label>
              </div>
              {errors.amendment_type && (
                <span className="error-message font-size-text">{errors.amendment_type}</span>
              )}
            </div>

            {amendmentType === "tenure" && (
              <div className="flex-column" style={{ marginBottom: 12 }}>
                <label className="form-labels font-weight500 font-size-subheading">
                  Tenure Changes <span className="required">*</span>
                </label>
                {changes.map((c, idx) => (
                  <div key={c.field} style={{ display: "flex", gap: 8, alignItems: "center", marginBottom: 8, flexWrap: "wrap" }}>
                    <span style={{ minWidth: 170, fontSize: 13, fontWeight: 500 }}>{c.label}</span>
                    <input
                      type="text"
                      readOnly
                      disabled
                      value={c.prev_value || "-"}
                      placeholder="Current value"
                      className="form-input font-weight400 font-size-subheading form-input-background"
                      style={{ minWidth: 130, background: "#f6f8fa", color: "#57606a" }}
                      title="Current value from the record"
                    />
                    <span style={{ color: "#8a97a3" }}>→</span>
                    <input
                      type="date"
                      value={c.new_value}
                      onChange={(e) => handleTenureDateChange(idx, e.target.value)}
                      className="form-input font-weight400 font-size-subheading form-input-background"
                      style={{ minWidth: 150 }}
                    />
                  </div>
                ))}
                {errors.changes && <span className="error-message font-size-text">{errors.changes}</span>}
              </div>
            )}

            {amendmentType === "other" && (
              <div className="flex-column" style={{ marginBottom: 12 }}>
                <label className="form-labels font-weight500 font-size-subheading">
                  Field Details <span className="required">*</span>
                </label>
                <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
                  <input
                    type="text"
                    placeholder="e.g. Tender Amendment"
                    value={changes[0]?.field || ""}
                    onChange={(e) => handleOtherFieldName(e.target.value)}
                    className="form-input font-weight400 font-size-subheading form-input-background"
                    style={{ minWidth: 220 }}
                  />
                  <input
                    type="text"
                    placeholder="New value"
                    value={changes[0]?.new_value || ""}
                    onChange={(e) => handleOtherNewValue(e.target.value)}
                    className="form-input font-weight400 font-size-subheading form-input-background"
                    style={{ minWidth: 160 }}
                  />
                </div>
                {errors.changes && <span className="error-message font-size-text">{errors.changes}</span>}
              </div>
            )}

            <div className="form-flex-wrap">
              <div className="flex-column">
                <label className="form-labels font-weight500 font-size-subheading">
                  Amended By <span className="required">*</span>
                </label>
                <input
                  type="text"
                  value={amendedBy}
                  onChange={(e) => setAmendedBy(e.target.value)}
                  className="form-input font-weight400 font-size-subheading form-input-background"
                  placeholder="Enter name"
                />
                {errors.amended_by && <span className="error-message font-size-text">{errors.amended_by}</span>}
              </div>

              <div className="flex-column" style={{ flex: 1, minWidth: 260 }}>
                <label className="form-labels font-weight500 font-size-subheading">
                  Remarks <span className="required">*</span>
                </label>
                <textarea
                  value={remarks}
                  onChange={(e) => setRemarks(e.target.value)}
                  className="form-input font-weight400 font-size-subheading form-input-background"
                  rows={2}
                  placeholder="e.g. Extended as per corrigendum notice dated 14-Aug-2026"
                />
                {errors.remarks && <span className="error-message font-size-text">{errors.remarks}</span>}
              </div>

              <div className="flex-column">
                <label className="form-labels font-weight500 font-size-subheading">Attachments (optional)</label>
                <input
                  type="file"
                  multiple
                  onChange={(e) => setAttachments((prev) => [...prev, ...Array.from(e.target.files || [])])}
                  className="form-control"
                />
                {attachments.length > 0 && (
                  <ul style={{ marginTop: 8, paddingLeft: 18 }}>
                    {attachments.map((file, idx) => (
                      <li key={idx} style={{ fontSize: 12 }}>
                        {file.name}
                        <button
                          type="button"
                          onClick={() => setAttachments((prev) => prev.filter((_, i) => i !== idx))}
                          style={{ marginLeft: 8, color: "red", border: "none", background: "none", cursor: "pointer" }}
                        >
                          ✕
                        </button>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
          </form>

          <div className="button-models">
            <button className="model-button font-weight500 model-button-cancel" onClick={handleClose}>
              Cancel
            </button>
            <button
              type="submit"
              className="model-button font-weight500 model-button-leave font-size-heading"
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading ? "Submitting..." : "Submit Amendment"}
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
// ! *************** Row Actions Menu (triple-dot dropdown) ***************
// ! *************** Row Actions Menu (triple-dot dropdown, portal-based) ***************
const RowActionsMenu = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [coords, setCoords] = useState({ top: 0, left: 0 });
  const btnRef = useRef(null);
  const menuRef = useRef(null);

  const computePosition = () => {
    const rect = btnRef.current?.getBoundingClientRect();
    if (!rect) return;
    const menuWidth = 170;
    let left = rect.right - menuWidth;
    if (left < 8) left = 8;
    setCoords({ top: rect.bottom + 4, left });
  };

  const handleToggle = (e) => {
    e.stopPropagation();
    if (!open) computePosition();
    setOpen((prev) => !prev);
  };

  useEffect(() => {
    if (!open) return;

    const handleClickOutside = (e) => {
      // Ignore clicks inside any react-bootstrap modal/backdrop —
      // those render in a separate portal outside menuRef/btnRef.
      if (e.target.closest(".modal") || e.target.closest(".modal-backdrop")) {
        return;
      }
      if (
        menuRef.current &&
        !menuRef.current.contains(e.target) &&
        btnRef.current &&
        !btnRef.current.contains(e.target)
      ) {
        setOpen(false);
      }
    };
    const handleReposition = () => computePosition();

    document.addEventListener("mousedown", handleClickOutside);
    window.addEventListener("scroll", handleReposition, true);
    window.addEventListener("resize", handleReposition);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      window.removeEventListener("scroll", handleReposition, true);
      window.removeEventListener("resize", handleReposition);
    };
  }, [open]);

  return (
    <div style={{ display: "inline-block" }} onClick={(e) => e.stopPropagation()}>
      <button
        ref={btnRef}
        type="button"
        title="Actions"
        onClick={handleToggle}
        style={{
          border: "1px solid #d0d7de",
          background: open ? "#f0f4f8" : "#fff",
          cursor: "pointer",
          fontSize: 16,
          lineHeight: 1,
          padding: "4px 10px",
          borderRadius: 6,
          color: "#24292f",
        }}
      >
        ⋮
      </button>

      {open &&
        ReactDOM.createPortal(
          <div
            ref={menuRef}
            style={{
              position: "fixed",
              top: coords.top,
              left: coords.left,
              background: "#fff",
              border: "1px solid #d0d7de",
              borderRadius: 8,
              boxShadow: "0 6px 16px rgba(0,0,0,0.18)",
              zIndex: 9999,
              minWidth: 170,
              display: "flex",
              flexDirection: "column",
              gap: 4,
              padding: 6,
            }}
          >
            {children}
          </div>,
          document.body,
        )}
    </div>
  );
};

// ! *************** Move From Closed/Expired Modal (replaces old MoveFromClosedModal) ***************
const CLOSED_MOVE_TARGETS = [
  { value: "created", label: "Created Emd" },
  { value: "submitted", label: "Submitted Emd" },
  { value: "matured", label: "Matured Emd" },
  { value: "released", label: "Released Emd" },
];

const MoveFromClosedModal = ({ item, getBgDetails }) => {
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [target, setTarget] = useState("");
  const [releaseDate, setReleaseDate] = useState("");

  const existingEmdType = item.emd_type_multi?.[0] || item.emd_type || "";
  const [backfillEmdType, setBackfillEmdType] = useState(existingEmdType);
  const [utrNumber, setUtrNumber] = useState("");
  const [releaseRemarks, setReleaseRemarks] = useState("");
  const [releaseFiles, setReleaseFiles] = useState([]);
  const [errors, setErrors] = useState({});

  // Effective type used for release: creation-time type, or the backfilled
  // value when it was never captured.
  const effectiveEmdType = existingEmdType || backfillEmdType;
  const creationRef = existingEmdType ? getCreationRefDisplay(item) : null;

  const handleClose = () => {
    setShow(false);
    setTarget("");
    setReleaseDate("");
    setBackfillEmdType(existingEmdType);
    setUtrNumber("");
    setReleaseRemarks("");
    setReleaseFiles([]);
    setErrors({});
  };
  const handleShow = () => setShow(true);

  const validate = () => {
    const newErrors = {};
    if (!target) newErrors.target = "Please select where to move this EMD.";
    if (target === "released") {
      if (!releaseDate) newErrors.release_date = "EMD Receiving Date is required!";
      if (!existingEmdType && !backfillEmdType) newErrors.backfill_emd_type = "EMD Type is required!";
      if (effectiveEmdType === "neft" && !utrNumber.trim()) {
        newErrors.utr_number = "UTR Number is required!";
      }
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const buildFlagsForTarget = () => {
    const flags = {
      is_cancelled: false,
      is_rejected: false,
      is_in_created: false,
      is_submitted: false,
      is_matured: false,
      is_released: false,
    };
    if (target === "created") {
      flags.is_in_created = true;
    } else if (target === "submitted") {
      flags.is_in_created = true;
      flags.is_submitted = true;
    } else if (target === "matured") {
      flags.is_in_created = true;
      flags.is_submitted = true;
      flags.is_matured = true;
    } else if (target === "released") {
      flags.is_in_created = true;
      flags.is_submitted = true;
      flags.is_matured = true;
      flags.is_released = true;
    }
    return flags;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setLoading(true);
    const loadingToastId = toast.loading("Moving EMD...");

    try {
      const flags = buildFlagsForTarget();

      if (target === "released") {
        let attachments = [];
        if (releaseFiles.length > 0) {
          setUploading(true);
          attachments = await uploadReleaseAttachments(item.id, releaseFiles);
          setUploading(false);
        }

        const releasedEmdDetail = {
          emd_type: effectiveEmdType,
          emd_receiving_date: releaseDate,
          remarks: releaseRemarks,
          ...(effectiveEmdType === "neft" ? { utr_number: utrNumber } : {}),
          attachments: attachments.map((a) => ({ id: a.id, file: a.file })),
        };

        const payload = { ...flags, released_emd_details: [releasedEmdDetail] };
        if (!existingEmdType) {
          payload.emd_type = backfillEmdType;
          payload.emd_type_multi = [backfillEmdType];
        }

        await axios.put(
          `${BASE_URL}/siteproject/bgdetailsforbdput/${item.id}/`,
          payload,
          { headers: { "Content-Type": "application/json" } },
        );
      } else {
        await axios.put(
          `${BASE_URL}/siteproject/bgdetailsforbdput/${item.id}/`,
          flags,
          { headers: { "Content-Type": "application/json" } },
        );
      }

      await getBgDetails();
      toast.dismiss(loadingToastId);
      toast.success(
        `Moved to ${CLOSED_MOVE_TARGETS.find((t) => t.value === target)?.label}`,
      );
      handleClose();
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setLoading(false);
      setUploading(false);
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>
      <button
        title="Move From Closed/Expired"
        className="tender-card__action-secondary"
        onClick={handleShow}
      >
        Move Tender
      </button>

      <Modal show={show} onHide={handleClose} dialogClassName="request-leave large-modal" size="lg">
        <Modal.Header closeButton className="justify-center task-Tab-heading font-weight500 font-size-heading">
          <Modal.Title>Move EMD — {item.tender_name || item.tender_id}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form className="register-from">
            <div className="form-flex-wrap">
              <div className="flex-column">
                <label className="form-labels font-weight500 font-size-subheading">
                  Move To <span className="required">*</span>
                </label>
                <select
                  value={target}
                  onChange={(e) => setTarget(e.target.value)}
                  className="form-input font-weight400 font-size-subheading form-input-background"
                >
                  <option value="">Select destination stage</option>
                  {CLOSED_MOVE_TARGETS.map((t) => (
                    <option key={t.value} value={t.value}>{t.label}</option>
                  ))}
                </select>
                {errors.target && (
                  <span className="error-message font-size-text">{errors.target}</span>
                )}
              </div>

              {target === "released" && (
                <>
                  <div className="flex-column">
                    <label className="form-labels font-weight500 font-size-subheading">
                      EMD Receiving Date <span className="required">*</span>
                    </label>
                    <input
                      type="date"
                      value={releaseDate}
                      onChange={(e) => setReleaseDate(e.target.value)}
                      className="form-input font-weight400 font-size-subheading form-input-background"
                    />
                    {errors.release_date && (
                      <span className="error-message font-size-text">{errors.release_date}</span>
                    )}
                  </div>

                  {existingEmdType ? (
                    <div className="flex-column">
                      <label className="form-labels font-weight500 font-size-subheading">EMD Type (on record)</label>
                      <input
                        type="text"
                        readOnly
                        disabled
                        value={formatEmdTypeLabel(existingEmdType)}
                        className="form-input font-weight400 font-size-subheading form-input-background"
                        style={{ background: "#f6f8fa" }}
                      />
                    </div>
                  ) : (
                    <div className="flex-column">
                      <label className="form-labels font-weight500 font-size-subheading">
                        EMD Type <span className="required">*</span>
                      </label>
                      <select
                        value={backfillEmdType}
                        onChange={(e) => setBackfillEmdType(e.target.value)}
                        className="form-input font-weight400 font-size-subheading form-input-background"
                      >
                        <option value="">Select EMD Type</option>
                        {EMD_TYPE_OPTIONS.map((t) => (
                          <option key={t.key} value={t.key}>{t.value}</option>
                        ))}
                      </select>
                      {errors.backfill_emd_type && (
                        <span className="error-message font-size-text">{errors.backfill_emd_type}</span>
                      )}
                    </div>
                  )}

                  {creationRef && (
                    <div className="flex-column">
                      <label className="form-labels font-weight500 font-size-subheading">
                        {creationRef.label} (on record)
                      </label>
                      <input
                        type="text"
                        readOnly
                        disabled
                        value={creationRef.value}
                        className="form-input font-weight400 font-size-subheading form-input-background"
                        style={{ background: "#f6f8fa", color: "#57606a" }}
                        title="Captured at EMD creation — for matching only"
                      />
                    </div>
                  )}

                  {effectiveEmdType === "neft" && (
                    <div className="flex-column">
                      <label className="form-labels font-weight500 font-size-subheading">
                        UTR Number <span className="required">*</span>
                      </label>
                      <input
                        type="text"
                        value={utrNumber}
                        onChange={(e) => setUtrNumber(e.target.value)}
                        className="form-input font-weight400 font-size-subheading form-input-background"
                        placeholder="Enter UTR Number"
                      />
                      {errors.utr_number && (
                        <span className="error-message font-size-text">{errors.utr_number}</span>
                      )}
                    </div>
                  )}

                  <div className="flex-column" style={{ flex: 1, minWidth: 260 }}>
                    <label className="form-labels font-weight500 font-size-subheading">Release Remarks</label>
                    <textarea
                      value={releaseRemarks}
                      onChange={(e) => setReleaseRemarks(e.target.value)}
                      className="form-input font-weight400 font-size-subheading form-input-background"
                      rows={2}
                      placeholder="Optional — e.g. Forfeited due to non-performance / Released after contract closure"
                    />
                  </div>

                  <div className="flex-column">
                    <label className="form-labels font-weight500 font-size-subheading">
                      Release Proof (optional)
                    </label>
                    <input
                      type="file"
                      multiple
                      onChange={(e) =>
                        setReleaseFiles((prev) => [...prev, ...Array.from(e.target.files || [])])
                      }
                      className="form-control"
                    />
                    {releaseFiles.length > 0 && (
                      <ul style={{ marginTop: 8, paddingLeft: 18 }}>
                        {releaseFiles.map((file, idx) => (
                          <li key={idx} style={{ fontSize: 12 }}>
                            {file.name}
                            <button
                              type="button"
                              onClick={() =>
                                setReleaseFiles((prev) => prev.filter((_, fi) => fi !== idx))
                              }
                              style={{ marginLeft: 8, color: "red", border: "none", background: "none", cursor: "pointer" }}
                            >
                              ✕
                            </button>
                          </li>
                        ))}
                      </ul>
                    )}
                    {uploading && (
                      <span style={{ fontSize: 12, color: "#57606a" }}>Uploading attachments...</span>
                    )}
                  </div>
                </>
              )}
            </div>
          </form>

          <div className="button-models">
            <button className="model-button font-weight500 model-button-cancel" onClick={handleClose}>
              Cancel
            </button>
            <button
              type="submit"
              className="model-button font-weight500 model-button-leave font-size-heading"
              onClick={handleSubmit}
              disabled={loading || uploading}
            >
              {uploading ? "Uploading..." : loading ? "Moving..." : "Confirm Move"}
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
// ! *************** Main BG Details Component ***************
const SubmittedTender = () => {
  const [buffer, setBuffering] = useState(true);
  const [bgData, setBgData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const location = useLocation();
  const [tenderId, setTenderId] = useState("");
  const [summaryData, setSummaryData] = useState({});
  const [dueDateSort, setDueDateSort] = useState("asc");
  const [showDownloadModal, setShowDownloadModal] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [companyProjectCode, setCompanyProjectCode] = useState("");

  const isClosedExpired = (item) => {
    // Explicit termination always closes the item, regardless of stage.
    if (item?.is_cancelled || item?.is_rejected) return true;

    // Only items still sitting in the Upcoming stage (not yet moved to
    // Created / Submitted / Matured) can be pushed to Closed/Expired
    // just because the deadline passed. Once an EMD has progressed past
    // Upcoming, it stays visible in its own tab even if the date lapses.
    const stillInUpcoming =
      !item?.is_in_created && !item?.is_submitted && !item?.is_matured;
    if (!stillInUpcoming) return false;

    const dateStr = item?.corrigendum_date || item?.submission_date;
    if (!dateStr) return false;

    const today = new Date();
    const target = new Date(dateStr);
    today.setHours(0, 0, 0, 0);
    target.setHours(0, 0, 0, 0);

    return target < today;
  };

  const getRowsForState = (state, dataSource) => {
    return dataSource.filter((i) => {
      switch (state) {
        case 1: return i?.is_in_upcoming && !i?.is_submitted && !i?.is_matured; // drop the !is_in_created requirement
        case 2: return i?.is_in_upcoming && i?.is_in_created && !i?.is_submitted && !i?.is_matured;
        case 3: return i?.is_in_upcoming && i?.is_submitted && !i?.is_matured;   // drop the is_in_created requirement
        case 4: return i?.is_in_upcoming && i?.is_matured;
        case 6: return isClosedExpired(i);
        default: return true;
      }
    });
  };

  const buildOldSheetData = (dataArray) =>
    dataArray.map((item) => ({
      "Project Name": item.project_name || "-",
      "Project Detail": item.project_name_in_detail || "-",
      BG: item.bg || "-",
      "Work Type": item.work_type || "-",
      "Lead Firm": item.lead_firm || "-",
      JV: item.jv || "-",
      "Association Firm": item.association_firm || "-",
      "On Behalf Of": item.on_behalf_of || "-",
      Type: item.type || "-",
      "Security Type": item.type_of_security || "-",
      "BG No": item.bank_gurentee_no || "-",
      "Issue Date": formatDate(item.bank_gurentee_issue_date),
      "Expiry Date": formatDate(item.bg_expiry_date),
      "Claim Period": formatDate(item.claim_period),
      Beneficiary: item.benificiary_name || "-",
      Amount: item.bg_amount || "-",
      "FD Number": item.fd_number || "-",
      Margin: item.margin || "-",
      "Submitted To BD": item.submitted_to_bd_dept || "-",
      "Submitted Date": formatDate(item.submitted_date),
      Person: item.person_name || "-",
      Bank: item.bank_name || "-",
      Company: item.company_name || "-",
      Limit: item.limit || "-",
      SFMS: item.sfms || "-",
      Responsibility: item.responsibility || "-",
    }));

  const appendOldSheet = (workbook, dataArray, sheetName) => {
    const exportData = buildOldSheetData(dataArray);
    if (!exportData.length) return false;
    const sheet = XLSX.utils.json_to_sheet(exportData);
    const widths = Object.keys(exportData[0]).map((key) => ({
      wch:
        Math.max(key.length, ...exportData.map((r) => String(r[key] || "").length)) + 2,
    }));
    sheet["!cols"] = widths;
    XLSX.utils.book_append_sheet(workbook, sheet, sheetName);
    return true;
  };

  const getBgDetails = async () => {
    setBuffering(true);
    try {
      const response = await axios.get(
        `${BASE_URL}/siteproject/bgdetailsforbdpost/`,
      );
      setBgData(response.data);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false);
    }
  };

  useEffect(() => {
    getBgDetails();
    if (location.state?.project) {
      setTenderId(location.state.project);
    }
  }, [location]);

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    return new Date(dateString).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  const formatBoolean = (value) => {
    if (value === true || value === "true") return "Yes";
    if (value === false || value === "false") return "No";
    return value || "-";
  };
  const groupAmendmentsByBatch = (amendments) => {
    if (!Array.isArray(amendments) || amendments.length === 0) return [];
    const batches = {};
    amendments.forEach((a) => {
      const key = a.batch_id || a.id;
      if (!batches[key]) {
        batches[key] = {
          batch_id: key,
          amended_by: a.amended_by,
          amended_at: a.amended_at,
          remarks: a.remarks,
          attachments: [],
          changes: [],
        };
      }
      batches[key].changes.push({
        field: a.field_name,
        label: a.field_label || a.field_name,
        old_value: a.old_value,
        new_value: a.new_value,
      });
      if (Array.isArray(a.attachments)) {
        a.attachments.forEach((att) => {
          const url = att?.file;
          if (url && !batches[key].attachments.some((x) => x.file === url)) {
            batches[key].attachments.push({ id: att.id, file: url });
          }
        });
      }
    });
    return Object.values(batches).sort((a, b) => new Date(b.amended_at) - new Date(a.amended_at));
  };

  const [toggleState, setToggleState] = useState(1);
  const [maturedSubTab, setMaturedSubTab] = useState("pending");
  const [activeCard, setActiveCard] = useState(null);
  const [bgSubTab, setBgSubTab] = useState("new");
  const [bgOldData, setBgOldData] = useState([]);
  const [amendmentHistoryOpen, setAmendmentHistoryOpen] = useState({});
  const toggleAmendmentHistory = (id, e) => {
    e.stopPropagation();
    setAmendmentHistoryOpen((prev) => ({ ...prev, [id]: !prev[id] }));
  };
  const [expandedCards, setExpandedCards] = useState({});
  const [rowDetailTab, setRowDetailTab] = useState({}); // { [item.id]: "details" | "release" }
  const getRowDetailTab = (id) => rowDetailTab[id] || "details";
  const setRowDetailTabFor = (id, tab, e) => {
    e.stopPropagation();
    setRowDetailTab((prev) => ({ ...prev, [id]: tab }));
  };

  const getBgDetailsold = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}/siteproject/bgdetailsforbdold/`,
      );
      setBgOldData(response.data);
    } catch (err) {
      handleErrorToast(err);
    }
  };

  const calculateSummaryData = (data) => {
    const result = {};
    data.forEach((item) => {
      let key;
      let shouldInclude = false;

      if (toggleState === 1) {
        shouldInclude = item?.is_in_upcoming && !item?.is_in_created && !item?.is_submitted && !item?.is_matured;
        if (shouldInclude) key = item.emd_type || "Unknown";
      } else if (toggleState === 2) {
        shouldInclude = item?.is_in_upcoming && item?.is_in_created && !item?.is_submitted && !item?.is_matured;
        if (shouldInclude) key = item.sector || "Unknown";
      } else if (toggleState === 3) {
        shouldInclude = item?.is_in_upcoming && item?.is_in_created && item?.is_submitted && !item?.is_matured;
        if (shouldInclude) key = item.client || "Unknown";
      } else if (toggleState === 4) {
        shouldInclude = item?.is_in_upcoming && item?.is_in_created && item?.is_submitted && item?.is_matured;
        if (shouldInclude) key = item.client || "Unknown";
      } else if (toggleState === 5) {
        shouldInclude = true;
        key = item.type || "Unknown";
      } else if (toggleState === 6) {
        shouldInclude = isClosedExpired(item);
        if (shouldInclude) key = item.sector || "Unknown";
      }

      if (shouldInclude && key) {
        let rawAmount = toggleState === 5 ? item.bg_amount : item.emd_amount;
        let amount = Number(String(rawAmount).replace(/,/g, "")) || 0;
        if (!result[key]) result[key] = { total: 0, count: 0 };
        result[key].total += amount;
        result[key].count += 1;
      }
    });
    return result;
  };
  const formatHeader = (key) => key.replace(/_/g, " ").replace(/^\w/, (c) => c.toUpperCase());
  const buildSheetData = (dataArray) => {
    const finalData = dataArray.map((item) => {
      const rawAmt = Number(String(item.emd_amount || "0").replace(/,/g, "")) || 0;

      const cost =
        rawAmt >= 10000000
          ? `₹${(rawAmt / 10000000).toFixed(1)} Cr`
          : rawAmt >= 100000
            ? `₹${(rawAmt / 100000).toFixed(1)} L`
            : rawAmt > 0
              ? `₹${rawAmt.toLocaleString("en-IN")}`
              : "-";

      const emdTypes = [
        ...(item.emd_type_multi?.map(formatEmdType) || []),
        ...(item.emd_type ? [formatEmdType(item.emd_type)] : []),
      ];

      return {
        "Tender ID": item.tender_id || "-",
        "Tender Name": item.tender_name || "-",
        Sector: item.sector || "-",
        Type: emdTypes.join(", ") || "-",
        Client: item.client || "-",
        State: item.state || "-",
        "Due Date": formatDate(item.corrigendum_date || item.submission_date),
        Cost: cost,

        // Expanded Details
        "Submission Type": item.emd_submission_type || "-",
        "RFP Cost": item.cost_of_rfp
          ? `₹${Number(item.cost_of_rfp).toLocaleString("en-IN")}`
          : "-",
        "RFP Cost Mode":
          item.cost_of_rfp_mode === "other"
            ? item.cost_of_rfp_mode_other || "Other"
            : item.cost_of_rfp_mode || "-",

        "Created By": item.bg_created_by || "-",
        "On Behalf Of": item.bg_created_on_behalf_of || "-",

        "Payer Bank": item.payer_bank?.toUpperCase() || "-",
        "Account Number": item.account_number || "-",
        "Account Holder": item.name_of_account_holder || "-",

        "Creation Date": formatDate(item.bg_creation_date),
        "Expiry Date": formatDate(item.bg_expiry_date),
        "Transaction Date": formatDate(item.bg_transcation_date),

        "Reference No": item.ref_no || "-",
        "NEFT ID": item.neft_transaction_id || "-",
        "Transaction ID": item.transcation_id || "-",

        "Insurer Company": item.insurer_company || "-",
        "Payee Name": item.payee_name || "-",

        "Lead Partner": item.lead_partner || "-",
        "JV Partner": item.jv_partner_name || "-",
        "Associate Partner": item.assosiate_partner || "-",

        "Tech Open": item.tech_open ? "Yes" : "No",
        "L1": item.are_we_l1 ? "Yes" : "No",
        "EMD Created": item.bg_created ? "Yes" : "No",
      };
    });

    return finalData;
  };
  const appendSheet = (workbook, dataArray, sheetName) => {
    const exportData = buildSheetData(dataArray);

    if (!exportData.length) return false;

    const sheet = XLSX.utils.json_to_sheet(exportData);

    const widths = Object.keys(exportData[0]).map((key) => ({
      wch: Math.max(
        key.length,
        ...exportData.map((r) => String(r[key] || "").length)
      ) + 2,
    }));

    sheet["!cols"] = widths;

    XLSX.utils.book_append_sheet(workbook, sheet, sheetName);

    return true;
  };
  const stageNameMap = {
    1: "Upcoming EMD",
    2: "Created EMD",
    3: "Submitted EMD",
    4: "Matured EMD",
    6: "Closed Expired EMD",
  };
  const handleDownloadChoice = (choice) => {
    setDownloadLoading(true);
    try {
      const workbook = XLSX.utils.book_new();

      if (choice === "current") {
        // Respects whatever the user currently has filtered + the active tab
        let added;
        if (toggleState === 5) {
          added = appendOldSheet(workbook, filteredData, "BG Old");
        } else {
          added = appendSheet(workbook, tabRows, stageNameMap[toggleState] || "EMD");
        }
        if (!added) {
          toast.info("No data available");
          return;
        }
        XLSX.writeFile(workbook, "EMD_Details_Current_Tab.xlsx");
      } else {
        // Ignores filters/tab — dumps every stage, each as its own sheet
        let anyAdded = false;
        [1, 2, 3, 4, 6].forEach((state) => {
          const rows = getRowsForState(state, bgData);
          if (appendSheet(workbook, rows, stageNameMap[state])) anyAdded = true;
        });
        if (appendOldSheet(workbook, bgOldData, "BG Old")) anyAdded = true;

        if (!anyAdded) {
          toast.info("No data available");
          return;
        }
        XLSX.writeFile(workbook, "EMD_Details_All.xlsx");
      }

      setShowDownloadModal(false);
      toast.success("Download ready!");
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setDownloadLoading(false);
    }
  };
  useEffect(() => {
    const newSummaryData = calculateSummaryData(filteredData);
    setSummaryData(newSummaryData);
  }, [filteredData, toggleState]);

  const [expandedState, setExpandedState] = useState("closed");
  const [selectedSector, setSelectedSector] = useState(null);
  const [selectedClient, setSelectedClient] = useState(null);
  const [selectedEmdType, setSelectedEmdType] = useState(null);
  const [activeCardKey, setActiveCardKey] = useState(null);

  const getSectorsWithCounts = () => {
    const sectors = {};
    filteredData
      .filter((item) => {
        if (toggleState === 1) return item?.is_in_upcoming && !item?.is_in_created && !item?.is_submitted && !item?.is_matured;
        else if (toggleState === 2) return item?.is_in_upcoming && item?.is_in_created && !item?.is_submitted && !item?.is_matured;
        else if (toggleState === 3) return item?.is_in_upcoming && item?.is_in_created && item?.is_submitted && !item?.is_matured;
        else if (toggleState === 4) return item?.is_in_upcoming && item?.is_in_created && item?.is_submitted && item?.is_matured;
        else if (toggleState === 6) return isClosedExpired(item);
        return false;
      })
      .forEach((item) => {
        const sector = item.sector || "Unknown";
        if (!sectors[sector]) sectors[sector] = 0;
        sectors[sector]++;
      });
    return Object.entries(sectors)
      .map(([name, count]) => ({ name, count }))
      .sort((a, b) => b.count - a.count);
  };

  const getEmdDetails = (sector, client, emdType) => {
    return filteredData.filter(
      (item) => item.sector === sector && item.client === client && item.emd_type === emdType,
    );
  };

  const handleReset = () => {
    setExpandedState("closed");
    setSelectedSector(null);
    setSelectedClient(null);
    setSelectedEmdType(null);
    setActiveCardKey(null);
    setMaturedSubTab("pending");
  };

  const getClientsWithCounts = (sector) => {
    const clients = {};
    filteredData
      .filter((item) => {
        if (item.sector !== sector) return false;
        if (toggleState === 1) return item?.is_in_upcoming && !item?.is_in_created && !item?.is_submitted && !item?.is_matured;
        else if (toggleState === 2) return item?.is_in_upcoming && item?.is_in_created && !item?.is_submitted && !item?.is_matured;
        else if (toggleState === 3) return item?.is_in_upcoming && item?.is_in_created && item?.is_submitted && !item?.is_matured;
        else if (toggleState === 4) return item?.is_in_upcoming && item?.is_in_created && item?.is_submitted && item?.is_matured;
        else if (toggleState === 6) return isClosedExpired(item);
        return false;
      })
      .forEach((item) => {
        const client = item.client || "Unknown";
        if (!clients[client]) clients[client] = 0;
        clients[client]++;
      });
    return Object.entries(clients).map(([name, count]) => ({ name, count }));
  };

  const getEmdTypesWithCounts = (sector, client) => {
    const emdTypes = {};
    filteredData
      .filter((item) => {
        const sectorClientMatch = item.sector === sector && item.client === client;
        if (!sectorClientMatch) return false;
        if (toggleState === 1) return item?.is_in_upcoming && !item?.is_in_created && !item?.is_submitted && !item?.is_matured;
        else if (toggleState === 2) return item?.is_in_upcoming && item?.is_in_created && !item?.is_submitted && !item?.is_matured;
        else if (toggleState === 3) return item?.is_in_upcoming && item?.is_in_created && item?.is_submitted && !item?.is_matured;
        else if (toggleState === 4) return item?.is_in_upcoming && item?.is_in_created && item?.is_submitted && item?.is_matured;
        else if (toggleState === 6) return isClosedExpired(item);
        return false;
      })
      .forEach((item) => {
        const type = item.emd_type || "Unknown";
        if (!emdTypes[type]) emdTypes[type] = { count: 0, amount: 0 };
        emdTypes[type].count++;
        emdTypes[type].amount += Number(String(item.emd_amount).replace(/,/g, "")) || 0;
      });
    return Object.entries(emdTypes).map(([name, data]) => ({ name, ...data }));
  };

  const getDueDays = (expiryDate, transactionDate, corrigendumDate, submissionDate) => {
    // Use corrigendum_date as the target if it exists, otherwise fall back to submission_date
    const targetDate = corrigendumDate || submissionDate || expiryDate || transactionDate;
    if (!targetDate) return "-";
    const today = new Date();
    const target = new Date(targetDate);
    today.setHours(0, 0, 0, 0);
    target.setHours(0, 0, 0, 0);
    const diffTime = target - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  };
  // Days between date_ff (Technical Open date) and today — used only in Matured EMD tab
  const getDaysSinceOpen = (dateFf) => {
    if (!dateFf) return "-";
    const today = new Date();
    const target = new Date(dateFf);
    today.setHours(0, 0, 0, 0);
    target.setHours(0, 0, 0, 0);
    const diffTime = today - target; // positive = date_ff is in the past
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  };

  useEffect(() => {
    getBgDetailsold();
  }, []);

  const [search, setSearch] = useState("");
  const [tendername, setTendername] = useState("");
  const [clientname, setClientname] = useState("");
  const [emdType, setEmdType] = useState("");
  const [projectname, setProjectname] = useState("");
  const [emdtypeold, setEmdTypeold] = useState("");
  const [selectedFromDate, setFromDate] = useState(null);
  const [selectedToDate, setToDate] = useState(null);

  const getTabCount = (tabState, dataSource) => {
    return dataSource
      ? dataSource.filter((tender) => {
        const closed = isClosedExpired(tender);

        switch (tabState) {
          case 1:
            return (
              !closed &&
              tender?.is_in_upcoming &&
              !tender?.is_submitted &&
              !tender?.is_matured
            );

          case 2:
            return (
              !closed &&
              tender?.is_in_upcoming &&
              tender?.is_in_created &&
              !tender?.is_submitted &&
              !tender?.is_matured
            );

          case 3:
            return (
              !closed &&
              tender?.is_in_upcoming &&
              tender?.is_submitted &&
              !tender?.is_matured
            );

          case 4:
            return (
              !closed &&
              tender?.is_in_upcoming &&
              tender?.is_matured
            );

          case 6:
            return closed;

          default:
            return false;
        }
      }).length
      : 0;
  };
  const isFilterActive = search !== "" || clientname !== "" || tendername !== "" || emdType !== "" || projectname !== "" || emdtypeold !== "" || companyProjectCode !== "" || selectedFromDate != null || selectedToDate != null;

  const applyFilters = () => {
    let filtered = toggleState === 5 ? bgOldData : bgData;

    if (search !== "") {
      const lowercaseSelectedName = search.toLowerCase();
      filtered = filtered.filter((project) =>
        project.tender_id?.toString().toLowerCase().includes(lowercaseSelectedName)
      );
    }
    if (companyProjectCode !== "") {
      const lowercaseSelectedName = companyProjectCode.toLowerCase();
      filtered = filtered.filter((project) =>
        project.company_project_code_bd?.toString().toLowerCase().includes(lowercaseSelectedName)
      );
    }
    if (clientname !== "") {
      const lowercaseSelectedName = clientname.toLowerCase();
      filtered = filtered.filter((project) =>
        project.client?.toString().toLowerCase().includes(lowercaseSelectedName)
      );
    }
    if (tendername !== "") {
      const lowercaseSelectedName = tendername.toLowerCase();
      filtered = filtered.filter((project) =>
        project.tender_name?.toString().toLowerCase().includes(lowercaseSelectedName)
      );
    }
    if (emdType !== "") {
      const lower = emdType.toLowerCase();
      filtered = filtered.filter((project) => {
        const inSingle = project.emd_type?.toString().toLowerCase().includes(lower);
        const inMulti = Array.isArray(project.emd_type_multi) &&
          project.emd_type_multi.some((t) => t.toLowerCase().includes(lower));
        return inSingle || inMulti;
      });
    }
    if (projectname !== "") {
      const lowercaseSelectedName = projectname.toLowerCase();
      filtered = filtered.filter((project) =>
        project.project_name?.toString().toLowerCase().includes(lowercaseSelectedName)
      );
    }
    if (emdtypeold !== "") {
      const lowercaseSelectedName = emdtypeold.toLowerCase();
      filtered = filtered.filter((project) =>
        project.type?.toString().toLowerCase().includes(lowercaseSelectedName)
      );
    }
    if (selectedFromDate != null && selectedToDate != null) {
      const fromDate = new Date(selectedFromDate);
      const toDate = new Date(selectedToDate);
      filtered = filtered.filter((project) => {
        if (!project.bg_expiry_date) return false;
        const expiryDate = new Date(project.bg_expiry_date);
        return expiryDate >= fromDate && expiryDate <= toDate;
      });
    }

    setFilteredData(filtered);
  };

  useEffect(() => {
    applyFilters();
  }, [
    search, clientname, tendername, emdType, projectname, emdtypeold, companyProjectCode,
    selectedFromDate, selectedToDate, toggleState, bgSubTab, bgData, bgOldData,
  ]);

  const toggleCollapse = () => setIsCollapsed(!isCollapsed);
  const [isCollapsed, setIsCollapsed] = useState(true);

  // const EmdType = [
  //   { key: "Bank_Gurantee", value: "Bank Gurantee" },
  //   { key: "neft", value: "NEFT" },
  //   { key: "demand_draft", value: "Demand Draft" },
  //   { key: "suretybond", value: "Surety Bond" },
  //   { key: "card", value: "Card" },
  //   { key: "other", value: "Other" },
  // ];
  const EmdType = useMemo(() => {
    const seen = new Set();
    const types = [];
    bgData.forEach((item) => {
      const multi = Array.isArray(item.emd_type_multi) ? item.emd_type_multi : [];
      const single = item.emd_type ? [item.emd_type] : [];
      [...multi, ...single].forEach((t) => {
        if (t && !seen.has(t)) {
          seen.add(t);
          types.push({
            key: t,
            value: t.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()),
          });
        }
      });
    });
    return types.sort((a, b) => a.value.localeCompare(b.value));
  }, [bgData]);

  const [dueAlerts, setDueAlerts] = useState([]);
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    if (toggleState === 2) {
      const filtered = bgData
        .filter((item) => item?.is_in_created && item?.is_in_upcoming && !item?.is_submitted && !item?.is_matured)
        .filter((item) => {
          const days = getDueDays(item.bg_expiry_date, item.bg_transcation_date);
          return days !== "-" && days <= 3;
        });
      setDueAlerts(filtered);
      setShowPopup(filtered.length > 0);
    } else {
      setShowPopup(false);
    }
  }, [toggleState, bgData]);

  const toggleCardExpand = (cardId) => {
    setExpandedCards((prev) => ({ ...prev, [cardId]: !prev[cardId] }));
  };
  const getTabFilteredRows = () => {
    return filteredData
      .filter((item) => {
        const closed = isClosedExpired(item);

        switch (toggleState) {
          case 1:
            return (
              !closed &&
              item?.is_in_upcoming &&
              !item?.is_submitted &&
              !item?.is_matured
            );

          case 2:
            return (
              !closed &&
              item?.is_in_upcoming &&
              item?.is_in_created &&
              !item?.is_submitted &&
              !item?.is_matured
            );

          case 3:
            return (
              !closed &&
              item?.is_in_upcoming &&
              item?.is_submitted &&
              !item?.is_matured
            );

          case 4:
            return (
              !closed &&
              item?.is_in_upcoming &&
              item?.is_matured
            );

          case 6:
            return closed;

          default:
            return true;
        }
      })
      .sort((a, b) => {
        const getEffectiveDate = (item) => {
          const dateString =
            item?.corrigendum_date || item?.submission_date;
          return dateString ? new Date(dateString) : null;
        };

        const dateA = getEffectiveDate(a);
        const dateB = getEffectiveDate(b);

        if (!dateA && !dateB) return 0;
        if (!dateA) return 1;
        if (!dateB) return -1;

        return dueDateSort === "asc"
          ? dateA - dateB
          : dateB - dateA;
      });
  };

  const getDueDaysBadgeClass = (days) => {
    if (days === "-") return "";
    if (days < 0) return "bg-days-badge bg-days-badge--expired";
    if (days <= 3) return "bg-days-badge bg-days-badge--urgent";
    if (days <= 7) return "bg-days-badge bg-days-badge--warn";
    return "bg-days-badge bg-days-badge--ok";
  };

  const formatEmdType = (str) =>
    str ? str.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()) : "-";

  const [selectedRows, setSelectedRows] = useState([]);

  const toggleRowSelect = (id) => {
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((r) => r !== id) : [...prev, id]
    );
  };

  const toggleSelectAll = () => {
    const rows = getTabFilteredRows();
    if (selectedRows.length === rows.length) {
      setSelectedRows([]);
    } else {
      setSelectedRows(rows.map((r) => r.id));
    }
  };

  const maturedRows = getTabFilteredRows();
  const pendingEmdCount = toggleState === 4 ? maturedRows.filter((i) => !i?.is_released).length : 0;
  const realisedEmdCount = toggleState === 4 ? maturedRows.filter((i) => !!i?.is_released).length : 0;
  const tabRows = toggleState === 4
    ? maturedRows.filter((i) =>
      maturedSubTab === "pending" ? !i?.is_released : !!i?.is_released
    )
    : maturedRows;

  return (
    <>
      <div className="attendance-history-cont">
        {showPopup && (
          <div className="due-popup-right">
            <div className="due-popup-header">
              <h4>⚠️ Due Alerts</h4>
              <button onClick={() => setShowPopup(false)}>✕</button>
            </div>
            <div className="due-popup-body">
              {dueAlerts.map((item, index) => {
                const days = getDueDays(item.bg_expiry_date, item.bg_transcation_date);
                return (
                  <div key={index} className="due-card">
                    <p className="item-title">{item.tender_id || "Item"}</p>
                    <p>Due in: <span className="alert-text">{days} days</span></p>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {/* PROGRESSIVE ACCORDION SYSTEM */}
        <div className="accordion-main-container">
          <div
            className={`accordion-trigger-button ${expandedState !== "closed" ? "active" : ""}`}
            onClick={() => {
              if (expandedState === "closed") {
                setExpandedState("sectors");
                setSelectedSector(null);
                setSelectedClient(null);
              } else {
                handleReset();
              }
            }}
          >
            <div className="button-content">
              <div className="button-label">Total EMD Value</div>
              <div className="button-value">
                ₹ {Object.values(summaryData).reduce((a, b) => a + b.total, 0).toLocaleString("en-IN")}
              </div>
              <div className="button-meta">
                {Object.values(summaryData).reduce((a, b) => a + b.count, 0)} EMDs
              </div>
            </div>
            <div className="button-icon">
              <span>{expandedState !== "closed" ? "−" : "+"}</span>
            </div>
          </div>

          {expandedState !== "closed" && filteredData.length > 0 && (
            <div className={`accordion-expansion sectors-panel ${expandedState === "sectors" ? "expanded" : "hidden"}`}>
              <div className="expansion-header">
                <h3>Select Sector</h3>
                <span className="count-badge">{getSectorsWithCounts().length} Sectors</span>
              </div>
              <div className="sectors-grid">
                {getSectorsWithCounts().map((sector) => (
                  <div
                    key={sector.name}
                    className={`sector-card ${selectedSector === sector.name ? "selected" : ""}`}
                    onClick={() => { setSelectedSector(sector.name); setSelectedClient(null); setExpandedState("clients"); setActiveCardKey(null); }}
                  >
                    <div className="card-header-text">
                      <div className="sector-name">{sector.name}</div>
                      <div className="sector-count">{sector.count}</div>
                    </div>
                    <div className="card-footer">
                      <span className="sector-items">{sector.count} Items</span>
                      <span className="expand-arrow">→</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {expandedState === "clients" && selectedSector && (
            <div className="accordion-expansion clients-panel">
              <div className="expansion-header">
                <button className="back-button" onClick={() => setExpandedState("sectors")}><span>←</span> Back to Sectors</button>
                <h3>{selectedSector}</h3>
                <span className="count-badge">{getClientsWithCounts(selectedSector).length} Clients</span>
              </div>
              <div className="clients-list">
                {getClientsWithCounts(selectedSector).length > 0 ? (
                  getClientsWithCounts(selectedSector).map((client) => (
                    <div
                      key={client.name}
                      className={`client-row ${selectedClient === client.name ? "selected" : ""}`}
                      onClick={() => { setSelectedClient(client.name); setExpandedState("cards"); }}
                    >
                      <div className="row-content">
                        <div className="client-name">{client.name}</div>
                        <div className="client-meta">{client.count} EMD Types</div>
                      </div>
                      <div className="row-action"><span className="expand-arrow">→</span></div>
                    </div>
                  ))
                ) : (
                  <div className="empty-state">No clients found</div>
                )}
              </div>
            </div>
          )}

          {toggleState !== 1 && expandedState === "cards" && selectedSector && selectedClient && (
            <div className="accordion-expansion cards-panel">
              <div className="expansion-header">
                <button className="back-button" onClick={() => setExpandedState("clients")}><span>←</span> Back to Clients</button>
                <h3>{selectedClient}</h3>
                <span className="count-badge">{getEmdTypesWithCounts(selectedSector, selectedClient).length} EMD</span>
              </div>
              <div className="emd-cards-grid">
                {getEmdTypesWithCounts(selectedSector, selectedClient).length > 0 ? (
                  getEmdTypesWithCounts(selectedSector, selectedClient).map((emdType) => (
                    <div
                      key={emdType.name}
                      className={`emd-card ${activeCardKey === emdType.name ? "expanded" : ""}`}
                      onClick={() => { setSelectedEmdType(emdType.name); setExpandedState("details"); }}
                    >
                      <div className="emd-card-header">
                        <h4>{emdType.name?.replace(/_/g, " ")?.replace(/\b\w/g, (c) => c.toUpperCase())}</h4>
                        <div className="emd-badge">{emdType.count}</div>
                      </div>
                      <div className="emd-card-body">
                        <div className="emd-value">
                          <span className="label">Total Amount</span>
                          <span className="amount">₹ {emdType.amount.toLocaleString("en-IN")}</span>
                        </div>
                        <div className="emd-stats">
                          <div className="stat">
                            <span className="stat-label">Items</span>
                            <span className="stat-value">{emdType.count}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="empty-state">No EMD types found</div>
                )}
              </div>
            </div>
          )}

          {expandedState === "details" && selectedSector && selectedClient && selectedEmdType && (
            <div className="accordion-expansion details-panel">
              <div className="expansion-header">
                <button className="back-button" onClick={() => setExpandedState("cards")}><span>←</span> Back to EMD Types</button>
                <h3>{selectedEmdType}</h3>
                <span className="count-badge">{getEmdDetails(selectedSector, selectedClient, selectedEmdType).length} Items</span>
              </div>
              <div className="details-container">
                <div className="details-grid">
                  {getEmdDetails(selectedSector, selectedClient, selectedEmdType).length > 0 ? (
                    getEmdDetails(selectedSector, selectedClient, selectedEmdType).map((item, index) => (
                      <div key={index} className="detail-card">
                        <div className="detail-card-header">
                          <span className="detail-id">{item.tender_id || item.id || "N/A"}</span>
                          <span className="detail-sr">#{index + 1}</span>
                        </div>
                        <div className="detail-row">
                          <span className="detail-label">NAME</span>
                          <span className="detail-value">{item.tender_name || "N/A"}</span>
                        </div>
                        <div className="detail-row">
                          <span className="detail-label">CLIENT</span>
                          <span className="detail-badge">{item.client || "N/A"}</span>
                        </div>
                        <div className="detail-row">
                          <span className="detail-label">SECTOR</span>
                          <span className="detail-badge sector">{item.sector || "N/A"}</span>
                        </div>
                        <div className="detail-row highlight">
                          <span className="detail-label">EMD</span>
                          <span className="detail-amount">₹{(item.emd_amount || 0).toLocaleString("en-IN")}</span>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="empty-state">No EMD details found</div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>

        {/* ── TOP CONTROLS BAR (matches screenshot row 1) ── */}
        <div className="bg-root" style={{ marginBottom: 0 }}>

          {/* ── TOP BAR: Sort controls (from original code) ── */}
          <div className="bg-topbar">
            <span className="bg-topbar-brand">EMD Details</span>
            <div style={{ marginLeft: "auto", display: "flex", alignItems: "center", gap: 8 }}>
              <span style={{ fontSize: 12, color: "#57606a", fontWeight: 600 }}>Sort by Due Date:</span>
              <button
                className={`bg-filter-btn ${dueDateSort === "asc" ? "bg-filter-btn--search" : "bg-filter-btn--clear"}`}
                onClick={() => setDueDateSort("asc")}
              >
                ↑ Oldest First
              </button>
              <button
                className={`bg-filter-btn ${dueDateSort === "desc" ? "bg-filter-btn--search" : "bg-filter-btn--clear"}`}
                onClick={() => setDueDateSort("desc")}
              >
                ↓ Newest First
              </button>
            </div>
          </div>

          {/* ── FILTERS: Collapsible, only fields from original code ── */}
          <div style={{ borderBottom: "1px solid #d0d7de", display: "flex", background: "#f6f8fa" }}>
            <div
              style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "8px 14px", cursor: "pointer", background: "#f6f8fa", flex: 1 }}
              onClick={toggleCollapse}
              role="button"
            >
              <span style={{ fontSize: 13, fontWeight: 700, color: "#185fa5" }}>Filters</span>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <path
                  d={isCollapsed ? "M6 9L12 15L18 9" : "M18 15L12 9L6 15"}
                  stroke="#185fa5"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <button className="bg-icon-btns" onClick={() => setShowDownloadModal(true)} style={{ marginLeft: "5px" }}>
              <DownloadIcon /> Download
            </button>

          </div>

          {!isCollapsed && (
            <div className="bg-filterbar" style={{ flexWrap: "wrap", gap: 10, padding: "10px 14px", alignItems: "flex-end" }}>
              {(toggleState === 1 || toggleState === 2 || toggleState === 3 || toggleState === 4 || toggleState === 6) && (
                <>
                  {/* Search By Company Project Code */}
                  <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                    <label className="bg-filter-label">Search By Company Project Code</label>
                    <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
                      <svg style={{ position: "absolute", left: 8, pointerEvents: "none" }} width="14" height="14" viewBox="0 0 24 24" fill="none">
                        <path d="M21 21l-4.35-4.35M11 19a8 8 0 1 1 0-16 8 8 0 0 1 0 16z" stroke="#9fbfe8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                      <input
                        className="bg-filter-input"
                        placeholder="Search By Internal ID"
                        type="text"
                        value={companyProjectCode}
                        onChange={(e) => setCompanyProjectCode(e.target.value)}
                        style={{ paddingLeft: 28, width: 200 }}
                      />
                    </div>
                  </div>
                  {/* Search By Tender Id */}
                  <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                    <label className="bg-filter-label">Search By Tender Id</label>
                    <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
                      <svg style={{ position: "absolute", left: 8, pointerEvents: "none" }} width="14" height="14" viewBox="0 0 24 24" fill="none">
                        <path d="M21 21l-4.35-4.35M11 19a8 8 0 1 1 0-16 8 8 0 0 1 0 16z" stroke="#9fbfe8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                      <input
                        className="bg-filter-input"
                        placeholder="Search By Tender Id"
                        type="text"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        style={{ paddingLeft: 28, width: 200 }}
                      />
                    </div>
                  </div>

                  {/* Search By Client Name */}
                  <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                    <label className="bg-filter-label">Search By Client Name</label>
                    <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
                      <svg style={{ position: "absolute", left: 8, pointerEvents: "none" }} width="14" height="14" viewBox="0 0 24 24" fill="none">
                        <path d="M21 21l-4.35-4.35M11 19a8 8 0 1 1 0-16 8 8 0 0 1 0 16z" stroke="#9fbfe8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                      <input
                        className="bg-filter-input"
                        placeholder="Search By Client Name"
                        type="text"
                        value={clientname}
                        onChange={(e) => setClientname(e.target.value)}
                        style={{ paddingLeft: 28, width: 200 }}
                      />
                    </div>
                  </div>

                  {/* Search By Tender Name */}
                  <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                    <label className="bg-filter-label">Search By Tender Name</label>
                    <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
                      <svg style={{ position: "absolute", left: 8, pointerEvents: "none" }} width="14" height="14" viewBox="0 0 24 24" fill="none">
                        <path d="M21 21l-4.35-4.35M11 19a8 8 0 1 1 0-16 8 8 0 0 1 0 16z" stroke="#9fbfe8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                      <input
                        className="bg-filter-input"
                        placeholder="Search By Tender Name"
                        type="text"
                        value={tendername}
                        onChange={(e) => setTendername(e.target.value)}
                        style={{ paddingLeft: 28, width: 200 }}
                      />
                    </div>
                  </div>

                  {/* Emd Type */}
                  <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                    <label className="bg-filter-label">Emd Type</label>
                    <select
                      className="bg-filter-select"
                      value={emdType}
                      onChange={(e) => setEmdType(e.target.value)}
                      style={{ minWidth: 200, height: 30 }}
                    >
                      <option value="">Select Emd Type</option>
                      {EmdType.map((emd) => (
                        <option key={emd.key} value={emd.key}>{emd.value}</option>
                      ))}
                    </select>
                  </div>
                </>
              )}

              {toggleState === 5 && (
                <>
                  {/* Search By Project Name */}
                  <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                    <label className="bg-filter-label">Search By Project Name</label>
                    <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
                      <svg style={{ position: "absolute", left: 8, pointerEvents: "none" }} width="14" height="14" viewBox="0 0 24 24" fill="none">
                        <path d="M21 21l-4.35-4.35M11 19a8 8 0 1 1 0-16 8 8 0 0 1 0 16z" stroke="#9fbfe8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                      <input
                        className="bg-filter-input"
                        placeholder="Search By Project Name"
                        type="text"
                        value={projectname}
                        onChange={(e) => setProjectname(e.target.value)}
                        style={{ paddingLeft: 28, width: 200 }}
                      />
                    </div>
                  </div>

                  {/* Search By Emd Type */}
                  <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                    <label className="bg-filter-label">Search By Emd Type</label>
                    <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
                      <svg style={{ position: "absolute", left: 8, pointerEvents: "none" }} width="14" height="14" viewBox="0 0 24 24" fill="none">
                        <path d="M21 21l-4.35-4.35M11 19a8 8 0 1 1 0-16 8 8 0 0 1 0 16z" stroke="#9fbfe8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                      <input
                        className="bg-filter-input"
                        placeholder="Search By Emd Type"
                        type="text"
                        value={emdtypeold}
                        onChange={(e) => setEmdTypeold(e.target.value)}
                        style={{ paddingLeft: 28, width: 200 }}
                      />
                    </div>
                  </div>

                  {/* Search By Expire Date Range */}
                  <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                    <label className="bg-filter-label">Search By Expire Date Range</label>
                    <DateRangePicker
                      startDate={selectedFromDate}
                      endDate={selectedToDate}
                      placeHolder1="DD/MM/YYYY"
                      placeHolder2="DD/MM/YYYY"
                      onChange={(start, end) => { setFromDate(start); setToDate(end); }}
                      className="custom-range-picker"
                    />
                  </div>
                </>
              )}
            </div>
          )}

          {/* ── TAB BAR ── */}
          <div className="bg-tabbar">
            {[1, 2, 3, 4].map((tabNum) => {
              const labels = ["Upcoming Emd", "Created Emd", "Submitted Emd", "Matured Emd"];
              const icons = ["fas fa-bolt", "fas fa-clipboard-list", "fas fa-check-circle", "fas fa-check-double"];
              const count = isFilterActive
                ? getTabCount(tabNum, filteredData)
                : getTabCount(tabNum, bgData);
              return (
                <button
                  key={tabNum}
                  className={`bg-tab ${toggleState === tabNum ? "bg-tab--active" : ""}`}
                  onClick={() => { setToggleState(tabNum); handleReset(); }}
                >
                  <i className={icons[tabNum - 1]}></i>
                  {labels[tabNum - 1]}
                  <span className="bg-tab-count">{count}</span>
                </button>
              );
            })}
            <button
              className={`bg-tab ${toggleState === 6 ? "bg-tab--active" : ""}`}
              onClick={() => { setToggleState(6); handleReset(); }}
            >
              <i className="fas fa-ban"></i>
              Closed/Expired
              <span className="bg-tab-count">
                {isFilterActive ? getTabCount(6, filteredData) : getTabCount(6, bgData)}
              </span>
            </button>
            <button
              className={`bg-tab ${toggleState === 5 ? "bg-tab--active" : ""}`}
              onClick={() => { setToggleState(5); handleReset(); }}
            >
              <i className="fas fa-archive"></i>
              BG Old
              <span className="bg-tab-count">{bgOldData.length}</span>
            </button>
          </div>
          {toggleState === 4 && (
            <div className="bg-subtab-bar">
              <button
                className={`bg-subtab ${maturedSubTab === "pending" ? "bg-subtab--active" : ""}`}
                onClick={() => setMaturedSubTab("pending")}
              >
                To be released
                <span className="bg-tab-count" style={{ marginLeft: 6 }}>{pendingEmdCount}</span>
              </button>
              <button
                className={`bg-subtab ${maturedSubTab === "realised" ? "bg-subtab--active" : ""}`}
                onClick={() => setMaturedSubTab("realised")}
              >
                Released EMD
                <span className="bg-tab-count" style={{ marginLeft: 6 }}>{realisedEmdCount}</span>
              </button>
            </div>
          )}

          {/* ── TABLE (replaces card list) ── */}
          <div className="bg-table-scroll" style={{ flex: 1, minHeight: 0 }}>
            {(toggleState !== 5) && (
              <table className="bg-table">
                <colgroup>
                  <col style={{ width: 36 }} />
                  <col style={{ width: 36 }} />
                  <col style={{ width: 140 }} />
                  <col style={{ width: "auto" }} />
                  <col style={{ width: 80 }} />
                  <col style={{ width: 100 }} />
                  <col style={{ width: 130 }} />
                  <col style={{ width: 110 }} />
                  <col style={{ width: 100 }} />
                  <col style={{ width: 80 }} />
                  <col style={{ width: 80 }} />
                </colgroup>
                <thead>
                  <tr>
                    <th className="bg-th bg-th--center">
                      <input
                        type="checkbox"
                        className="bg-chk"
                        checked={tabRows.length > 0 && selectedRows.length === tabRows.length}
                        onChange={toggleSelectAll}
                      />
                    </th>
                    <th className="bg-th bg-th--center">#</th>
                    <th className="bg-th">Internal ID</th>
                    <th className="bg-th">Tender Name</th>
                    <th className="bg-th">Sector</th>
                    <th className="bg-th">Type</th>
                    <th className="bg-th">Client</th>
                    <th className="bg-th">State</th>
                    <th className="bg-th bg-th--sortable" onClick={() => setDueDateSort(dueDateSort === "asc" ? "desc" : "asc")}>
                      {toggleState === 4 ? "Technical Open Date" : "Due Date"} {dueDateSort === "asc" ? "↑" : "↓"}
                    </th>
                    <th className="bg-th bg-th--right">Cost</th>
                    <th className="bg-th bg-th--center">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {buffer ? (
                    // <tr className="bg-loader-row">
                    //   <td colSpan={11}>Loading...</td>
                    // </tr>

                    <tr className="bg-loader-row"><td colSpan={15}><AimantraLoading /></td></tr>

                  ) : tabRows.length > 0 ? (
                    tabRows.map((item, index) => {
                      const isExpanded = !!expandedCards[item.id];
                      const isSelected = selectedRows.includes(item.id);
                      const dueDays = getDueDays(item.corrigendum_date, item.submission_date, item.bg_expiry_date, item.bg_transcation_date);
                      const daysSinceOpen = toggleState === 4 ? getDaysSinceOpen(item.date_ff) : null;
                      const multiTypes = item.emd_type_multi?.length
                        ? item.emd_type_multi.map(formatEmdType)
                        : [];
                      const singleType = item.emd_type ? [formatEmdType(item.emd_type)] : [];
                      const allEmdTypes = [...multiTypes, ...singleType];

                      // Format cost
                      const rawAmt = Number(String(item.emd_amount || "0").replace(/,/g, "")) || 0;
                      const costCr = rawAmt >= 10000000
                        ? `₹${(rawAmt / 10000000).toFixed(1)}cr`
                        : rawAmt >= 100000
                          ? `₹${(rawAmt / 100000).toFixed(1)}L`
                          : rawAmt > 0
                            ? `₹${rawAmt.toLocaleString("en-IN")}`
                            : "–";

                      return (
                        <>
                          <tr
                            key={item.id}
                            className={`bg-rows ${index % 2 === 1 ? "bg-rows--even" : ""} ${isSelected ? "bg-rows--selected" : ""} ${isExpanded ? "bg-rows--expanded" : ""}`}
                            onClick={() => toggleCardExpand(item.id)}
                          >
                            {/* Checkbox */}
                            <td className="bg-td bg-td--check" onClick={(e) => e.stopPropagation()}>
                              <input
                                type="checkbox"
                                className="bg-chk"
                                checked={isSelected}
                                onChange={() => toggleRowSelect(item.id)}
                              />
                            </td>
                            {/* # */}
                            <td className="bg-td bg-td--center bg-td--small">{index + 1}</td>
                            {/* Tender ID */}
                            <td className="bg-td bg-td--id">{item?.company_project_code_bd || "N/A"}</td>
                            {/* Tender Name */}
                            <td className="bg-td bg-td--name" title={`${item?.tender_id || ""} — ${item?.tender_name || ""}`}>
                              <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
                                <span style={{ fontWeight: 600, color: "#0056b3", fontSize: 11 }}>
                                  {item?.tender_id || "N/A"}
                                </span>
                                <span>{item?.tender_name || "Unnamed Tender"}</span>
                              </div>
                            </td>
                            {/* Sector */}
                            <td className="bg-td">
                              {item.sector ? (
                                <span className="bg-sector-badge">{item.sector}</span>
                              ) : "-"}
                            </td>
                            {/* Type (EMD type) */}
                            <td className="bg-td bg-td--small">
                              {allEmdTypes.length > 0 ? allEmdTypes.join(", ") : "-"}
                            </td>
                            {/* Client */}
                            <td className="bg-td bg-td--small">{item.client || "-"}</td>
                            {/* State */}
                            <td className="bg-td bg-td--small">{item.state || "-"}</td>
                            {/* Submission date */}
                            <td className="bg-td bg-td--small" style={{ color: "#185fa5", fontWeight: 600 }}>
                              {toggleState === 4
                                ? (item.date_ff ? formatDate(item.date_ff) : "-")
                                : (() => {
                                  const displayDate = item.corrigendum_date || item.submission_date;
                                  return displayDate ? formatDate(displayDate) : "-";
                                })()}

                              {toggleState === 4 && daysSinceOpen !== "-" && daysSinceOpen !== null && (
                                <div style={{ marginTop: 2 }}>
                                  <span className={getDueDaysBadgeClass(daysSinceOpen)}>
                                    {daysSinceOpen < 0
                                      ? `${Math.abs(daysSinceOpen)}d until open`
                                      : `${daysSinceOpen}d since open`}
                                  </span>
                                </div>
                              )}

                              {(toggleState === 2 || toggleState === 3) && dueDays !== "-" && (
                                <div style={{ marginTop: 2 }}>
                                  <span className={getDueDaysBadgeClass(dueDays)}>
                                    {dueDays < 0 ? `${Math.abs(dueDays)}d overdue` : `${dueDays}d left`}
                                  </span>
                                </div>
                              )}

                              {toggleState === 6 && (
                                <div style={{ marginTop: 2 }}>
                                  <span className="bg-days-badge bg-days-badge--expired">
                                    {item?.is_cancelled
                                      ? "Cancelled"
                                      : item?.is_rejected
                                        ? "Rejected"
                                        : "Expired"}
                                  </span>
                                </div>
                              )}
                            </td>
                            {/* Cost */}
                            <td className="bg-td bg-td--right" style={{ fontWeight: 600, fontSize: 11 }}>
                              {costCr}
                            </td>
                            {/* Actions */}
                            <td className="bg-td bg-td--center" onClick={(e) => e.stopPropagation()}>
                              <RowActionsMenu>
                                <UpdateBgDetails i={item} getBgDetails={getBgDetails} toggleState={toggleState} />
                                <EmdAmendmentModal item={item} getBgDetails={getBgDetails} />
                                {toggleState === 6 && (
                                  <MoveFromClosedModal item={item} getBgDetails={getBgDetails} />
                                )}
                                {toggleState === 6
                                  ? null
                                  : toggleState === 4
                                    ? maturedSubTab === "pending" && (
                                      <MoveToNextStage i={item} getBgDetails={getBgDetails} toggleState={toggleState} />
                                    )
                                    : (
                                      <MoveToNextStage i={item} getBgDetails={getBgDetails} toggleState={toggleState} />
                                    )}
                              </RowActionsMenu>
                            </td>
                          </tr>

                          {/* ── EXPANDED DETAILS ROW ── */}
                          {isExpanded && (toggleState === 1 || toggleState === 2 || toggleState === 3 || toggleState === 4 || toggleState === 6) && (
                            <tr key={`${item.id}-exp`} className="bg-expand-row">
                              <td colSpan={11}>
                                <div className="bg-exp-body">
                                  {toggleState === 4 && item.released_emd_details?.length > 0 && (
                                    <div style={{ display: "flex", gap: 4, marginBottom: 12, borderBottom: "1px solid #e3e8ee" }}>
                                      <button
                                        type="button"
                                        onClick={(e) => setRowDetailTabFor(item.id, "details", e)}
                                        style={{
                                          border: "none",
                                          background: "none",
                                          cursor: "pointer",
                                          padding: "6px 14px",
                                          fontSize: 12,
                                          fontWeight: 600,
                                          color: getRowDetailTab(item.id) === "details" ? "#185fa5" : "#57606a",
                                          borderBottom: getRowDetailTab(item.id) === "details" ? "2px solid #185fa5" : "2px solid transparent",
                                        }}
                                      >
                                        EMD Details
                                      </button>
                                      <button
                                        type="button"
                                        onClick={(e) => setRowDetailTabFor(item.id, "release", e)}
                                        style={{
                                          border: "none",
                                          background: "none",
                                          cursor: "pointer",
                                          padding: "6px 14px",
                                          fontSize: 12,
                                          fontWeight: 600,
                                          color: getRowDetailTab(item.id) === "release" ? "#185fa5" : "#57606a",
                                          borderBottom: getRowDetailTab(item.id) === "release" ? "2px solid #185fa5" : "2px solid transparent",
                                        }}
                                      >
                                        Release Details
                                        {item.released_emd_details.length > 1 ? ` (${item.released_emd_details.length})` : ""}
                                      </button>
                                    </div>
                                  )}

                                  {getRowDetailTab(item.id) === "release" && item.released_emd_details?.length > 0 ? (
                                    <div className="bg-release-details">
                                      {item.released_emd_details.map((rd, rIdx) => {
                                        const opt = getReleaseEmdTypeOption(rd.emd_type);
                                        const refValue = opt ? rd[opt.field] : null;

                                        return (
                                          <div
                                            key={rIdx}
                                            style={{
                                              border: "1px solid #e3e8ee",
                                              borderRadius: 8,
                                              padding: 12,
                                              marginBottom: 10,
                                              background: "#f8fafc",
                                            }}
                                          >
                                            <div className="bg-detail-grid">
                                              <div className="bg-field">
                                                <span className="bg-field-label">EMD Received Type</span>
                                                <span className="bg-field-value">
                                                  {opt?.label || formatEmdType(rd.emd_type)}
                                                </span>
                                              </div>

                                              <div className="bg-field">
                                                <span className="bg-field-label">Receiving Date</span>
                                                <span className="bg-field-value">
                                                  {formatDate(rd.emd_receiving_date)}
                                                </span>
                                              </div>

                                              {opt && (
                                                <div className="bg-field">
                                                  <span className="bg-field-label">{opt.fieldLabel}</span>
                                                  <span className="bg-field-value">
                                                    {refValue || "-"}
                                                  </span>
                                                </div>
                                              )}

                                              {rd.remarks && (
                                                <div className="bg-field bg-field--full">
                                                  <span className="bg-field-label">Remarks</span>
                                                  <span className="bg-field-value">{rd.remarks}</span>
                                                </div>
                                              )}

                                              {rd.attachments?.length > 0 && (
                                                <div className="bg-field bg-field--full">
                                                  <span className="bg-field-label">Attachments</span>

                                                  <span className="bg-field-value">
                                                    {rd.attachments.map((att, ai) => (
                                                      <a
                                                        key={att.id ?? ai}
                                                        href={att.file}
                                                        target="_blank"
                                                        rel="noreferrer"
                                                        className="proof-links"
                                                        style={{ marginRight: 8 }}
                                                      >
                                                        📎 File {rd.attachments.length > 1 ? ai + 1 : ""}
                                                      </a>
                                                    ))}
                                                  </span>
                                                </div>
                                              )}
                                            </div>
                                          </div>
                                        );
                                      })}
                                    </div>
                                  ) : (
                                    <div className="bg-detail-grid">

                                      {/* Submission Info */}
                                      {item.emd_submission_type && (
                                        <div className="bg-field">
                                          <span className="bg-field-label">Submission Type</span>
                                          <span className="bg-field-value">{item.emd_submission_type}</span>
                                        </div>
                                      )}

                                      {item.cost_of_rfp && (
                                        <div className="bg-field">
                                          <span className="bg-field-label">RFP Cost</span>
                                          <span className="bg-field-value">
                                            ₹{Number(item.cost_of_rfp).toLocaleString("en-IN")}
                                          </span>
                                        </div>
                                      )}

                                      {item.cost_of_rfp_mode && (
                                        <div className="bg-field">
                                          <span className="bg-field-label">RFP Cost Mode</span>
                                          <span className="bg-field-value">
                                            {item.cost_of_rfp_mode === "other"
                                              ? item.cost_of_rfp_mode_other || "Other"
                                              : item.cost_of_rfp_mode.charAt(0).toUpperCase() +
                                              item.cost_of_rfp_mode.slice(1)}
                                          </span>
                                        </div>
                                      )}

                                      {item.bg_created_by && (
                                        <div className="bg-field">
                                          <span className="bg-field-label">Created By</span>
                                          <span className="bg-field-value">{item.bg_created_by}</span>
                                        </div>
                                      )}

                                      {item.bg_created_on_behalf_of && (
                                        <div className="bg-field">
                                          <span className="bg-field-label">On Behalf Of</span>
                                          <span className="bg-field-value">{item.bg_created_on_behalf_of}</span>
                                        </div>
                                      )}

                                      {/* Bank Details */}
                                      {item.payer_bank && (
                                        <div className="bg-field">
                                          <span className="bg-field-label">Payer Bank</span>
                                          <span className="bg-field-value">{item.payer_bank.toUpperCase()}</span>
                                        </div>
                                      )}

                                      {item.account_number && (
                                        <div className="bg-field">
                                          <span className="bg-field-label">Account No</span>
                                          <span className="bg-field-value">{item.account_number}</span>
                                        </div>
                                      )}

                                      {item.name_of_account_holder && (
                                        <div className="bg-field">
                                          <span className="bg-field-label">Account Holder</span>
                                          <span className="bg-field-value">{item.name_of_account_holder}</span>
                                        </div>
                                      )}

                                      {/* Transaction Details */}
                                      {item.bg_creation_date && (
                                        <div className="bg-field">
                                          <span className="bg-field-label">Creation Date</span>
                                          <span className="bg-field-value">{formatDate(item.bg_creation_date)}</span>
                                        </div>
                                      )}

                                      {item.bg_expiry_date && (
                                        <div className="bg-field">
                                          <span className="bg-field-label">Expiry Date</span>
                                          <span className="bg-field-value">{formatDate(item.bg_expiry_date)}</span>
                                        </div>
                                      )}

                                      {item.bg_transcation_date && (
                                        <div className="bg-field">
                                          <span className="bg-field-label">Transaction Date</span>
                                          <span className="bg-field-value">{formatDate(item.bg_transcation_date)}</span>
                                        </div>
                                      )}

                                      {/* Type-specific reference: ref_no shown as BG/DD/Surety Bond
                                          Number, transcation_id shown for NEFT/Card — same value the
                                          Move-to-Released modal shows for matching */}
                                      {(() => {
                                        const refDisplay = getCreationRefDisplay(item);
                                        return refDisplay ? (
                                          <div className="bg-field">
                                            <span className="bg-field-label">{refDisplay.label}</span>
                                            <span className="bg-field-value">{refDisplay.value}</span>
                                          </div>
                                        ) : null;
                                      })()}

                                      {/* Other */}
                                      {item.insurer_company && (
                                        <div className="bg-field">
                                          <span className="bg-field-label">Insurer Company</span>
                                          <span className="bg-field-value">{item.insurer_company}</span>
                                        </div>
                                      )}

                                      {item.payee_name && (
                                        <div className="bg-field">
                                          <span className="bg-field-label">Payee Name</span>
                                          <span className="bg-field-value">{item.payee_name}</span>
                                        </div>
                                      )}

                                      <div className="bg-field bg-field--full">
                                        <span className="bg-field-label">EMD Proof</span>
                                        <span className="bg-field-value">
                                          {item.emd_proofs && item.emd_proofs.length > 0 ? (
                                            item.emd_proofs.map(function (proof, pIdx) {
                                              return React.createElement(
                                                "a",
                                                {
                                                  key: proof.id ?? pIdx,
                                                  href: proof.file,
                                                  target: "_blank",
                                                  rel: "noreferrer",
                                                  className: "proof-links",
                                                  style: { marginRight: 8 },
                                                },
                                                "File " + (item.emd_proofs.length > 1 ? pIdx + 1 : "")
                                              );
                                            })
                                          ) : item.emd_created_proof ? (
                                            React.createElement(
                                              "a",
                                              {
                                                href: item.emd_created_proof,
                                                target: "_blank",
                                                rel: "noreferrer",
                                                className: "proof-links",
                                              },
                                              "View"
                                            )
                                          ) : (
                                            "-"
                                          )}
                                        </span>
                                      </div>

                                      <div className="bg-field">
                                        <span className="bg-field-label">Status</span>
                                        <span className="bg-field-value">
                                          <span
                                            className="badge-blues"
                                            style={{ marginRight: 4 }}
                                          >
                                            Tech Open: {item.tech_open ? "Yes" : "No"}
                                          </span>

                                          <span className="badge-greens">
                                            L1: {item.are_we_l1 ? "Yes" : "No"}
                                          </span>
                                        </span>
                                      </div>

                                      <div className="bg-field">
                                        <span className="bg-field-label">EMD Created</span>
                                        <span className="bg-field-value">
                                          {formatBoolean(item.bg_created)}
                                        </span>
                                      </div>

                                      {toggleState === 4 && (
                                        <div className="bg-field">
                                          <span className="bg-field-label">EMD Released</span>
                                          <span className="bg-field-value">
                                            {formatBoolean(item.is_released)}
                                          </span>
                                        </div>
                                      )}

                                      {toggleState === 6 && (
                                        <div className="bg-field">
                                          <span className="bg-field-label">Reason</span>
                                          <span className="bg-field-value">
                                            {item?.is_cancelled
                                              ? "Cancelled"
                                              : item?.is_rejected
                                                ? "Rejected"
                                                : "Submission date passed"}
                                          </span>
                                        </div>
                                      )}

                                      {toggleState === 4 &&
                                        item.result_open &&
                                        (() => {
                                          const today = new Date();
                                          const resultDate = new Date(item.result_open);
                                          const diffDays = Math.floor(
                                            (today - resultDate) / (1000 * 60 * 60 * 24)
                                          );

                                          return (
                                            <div className="bg-field">
                                              <span className="bg-field-label">Days Since Result</span>
                                              <span className="bg-field-value due-days-alert">
                                                {diffDays} days
                                              </span>
                                            </div>
                                          );
                                        })()}

                                      {/* Partners */}
                                      {(item.lead_partner ||
                                        item.jv_partner_name ||
                                        item.assosiate_partner) && (
                                          <div className="bg-field bg-field--full">
                                            <span className="bg-field-label">Partners</span>

                                            <span className="bg-field-value">
                                              {item.lead_partner && (
                                                <span
                                                  className="emd-partner-tag emd-partner-tag--lead"
                                                  style={{ marginRight: 6 }}
                                                >
                                                  <span className="emd-partner-tag__label">Lead</span>
                                                  {item.lead_partner}
                                                </span>
                                              )}

                                              {item.jv_partner_name && (
                                                <span
                                                  className="emd-partner-tag emd-partner-tag--jv"
                                                  style={{ marginRight: 6 }}
                                                >
                                                  <span className="emd-partner-tag__label">JV</span>
                                                  {item.jv_partner_name}
                                                </span>
                                              )}

                                              {item.assosiate_partner && (
                                                <span className="emd-partner-tag emd-partner-tag--assoc">
                                                  <span className="emd-partner-tag__label">
                                                    Associate
                                                  </span>
                                                  {item.assosiate_partner}
                                                </span>
                                              )}
                                            </span>
                                          </div>
                                        )}

                                      {/* Amendment History */}
                                      <div className="bg-field bg-field--full">
                                        <span
                                          className="bg-field-label"
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                          }}
                                        >
                                          <span>Amendment History</span>

                                          {groupAmendmentsByBatch(item.EmdAmendment).length > 0 && (
                                            <button
                                              type="button"
                                              onClick={(e) =>
                                                toggleAmendmentHistory(item.id, e)
                                              }
                                              style={{
                                                border: "none",
                                                background: "none",
                                                color: "#185fa5",
                                                cursor: "pointer",
                                                fontSize: 11,
                                                fontWeight: 600,
                                              }}
                                            >
                                              {amendmentHistoryOpen[item.id]
                                                ? "Hide ▲"
                                                : `Show (${groupAmendmentsByBatch(item.EmdAmendment).length}) ▼`}
                                            </button>
                                          )}
                                        </span>

                                        <span className="bg-field-value">
                                          {(() => {
                                            const batches = groupAmendmentsByBatch(
                                              item.EmdAmendment
                                            );

                                            if (batches.length === 0) {
                                              return "No amendments recorded";
                                            }

                                            if (!amendmentHistoryOpen[item.id]) {
                                              const latest = batches[0];

                                              return (
                                                <div
                                                  style={{
                                                    fontSize: 11,
                                                    color: "#57606a",
                                                  }}
                                                >
                                                  Last:{" "}
                                                  {latest.changes
                                                    .map((c) => c.label)
                                                    .join(", ")}{" "}
                                                  by {latest.amended_by || "-"} on{" "}
                                                  {formatDate(latest.amended_at)}
                                                </div>
                                              );
                                            }

                                            return (
                                              <div
                                                style={{
                                                  maxHeight: 220,
                                                  overflowY: "auto",
                                                  display: "flex",
                                                  flexDirection: "column",
                                                  gap: 6,
                                                  paddingRight: 4,
                                                }}
                                              >
                                                {batches.map((batch) => (
                                                  <div
                                                    key={batch.batch_id}
                                                    style={{
                                                      border: "1px solid #e3e8ee",
                                                      borderRadius: 6,
                                                      padding: "6px 8px",
                                                      fontSize: 11,
                                                    }}
                                                  >
                                                    <div
                                                      style={{
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        fontWeight: 600,
                                                        color: "#185fa5",
                                                      }}
                                                    >
                                                      <span>{batch.amended_by || "-"}</span>

                                                      <span
                                                        style={{
                                                          color: "#8a97a3",
                                                          fontWeight: 400,
                                                        }}
                                                      >
                                                        {formatDate(batch.amended_at)}
                                                      </span>
                                                    </div>

                                                    {batch.remarks && (
                                                      <div
                                                        style={{
                                                          color: "#57606a",
                                                          marginTop: 2,
                                                        }}
                                                      >
                                                        {batch.remarks}
                                                      </div>
                                                    )}

                                                    <div
                                                      style={{
                                                        marginTop: 4,
                                                        display: "flex",
                                                        flexWrap: "wrap",
                                                        gap: "2px 12px",
                                                      }}
                                                    >
                                                      {batch.changes.map((c, ci) => (
                                                        <span key={ci}>
                                                          <strong>{c.label}:</strong>{" "}
                                                          {c.old_value || "-"} →{" "}
                                                          {c.new_value}
                                                        </span>
                                                      ))}
                                                    </div>

                                                    {batch.attachments.length > 0 && (
                                                      <div
                                                        style={{
                                                          marginTop: 4,
                                                          display: "flex",
                                                          gap: 8,
                                                          flexWrap: "wrap",
                                                        }}
                                                      >
                                                        {batch.attachments.map((att, ai) => (
                                                          <a
                                                            key={att.id ?? ai}
                                                            href={att.file}
                                                            target="_blank"
                                                            rel="noreferrer"
                                                            className="proof-links"
                                                          >
                                                            📎 File{" "}
                                                            {batch.attachments.length > 1
                                                              ? ai + 1
                                                              : ""}
                                                          </a>
                                                        ))}
                                                      </div>
                                                    )}
                                                  </div>
                                                ))}
                                              </div>
                                            );
                                          })()}
                                        </span>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </td>
                            </tr>
                          )}
                        </>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={11} className="bg-empty-row">
                        <div>📋</div>
                        <div>No BG details found</div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            )}

            {/* ✅ BG OLD TABLE */}
            {toggleState === 5 && (
              <>
                <div className="repo-heading flex-row justify-between">
                  <span>BG Old Records</span>
                  <UploadBgOld getBgOldData={getBgDetailsold} />
                </div>
                <div className="bg-table-scroll" style={{ overflowX: "auto" }}>
                  <table className="bg-table" style={{ minWidth: 2800 }}>
                    <thead>
                      <tr>
                        <th className="bg-th">Sr. No</th>
                        <th className="bg-th">Project Name</th>
                        <th className="bg-th">Project Detail</th>
                        <th className="bg-th">BG</th>
                        <th className="bg-th">Work Type</th>
                        <th className="bg-th">Lead Firm</th>
                        <th className="bg-th">JV</th>
                        <th className="bg-th">Association Firm</th>
                        <th className="bg-th">On Behalf Of</th>
                        <th className="bg-th">Type</th>
                        <th className="bg-th">Security Type</th>
                        <th className="bg-th">BG No</th>
                        <th className="bg-th">Issue Date</th>
                        <th className="bg-th">Expiry Date</th>
                        <th className="bg-th">Claim Period</th>
                        <th className="bg-th">Beneficiary</th>
                        <th className="bg-th">Amount</th>
                        <th className="bg-th">FD Number</th>
                        <th className="bg-th">Margin</th>
                        <th className="bg-th">Submitted To BD</th>
                        <th className="bg-th">Submitted Date</th>
                        <th className="bg-th">Person</th>
                        <th className="bg-th">Bank</th>
                        <th className="bg-th">Company</th>
                        <th className="bg-th">Limit</th>
                        <th className="bg-th">SFMS</th>
                        <th className="bg-th">Responsibility</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredData?.length > 0 ? (
                        filteredData.map((item, i) => (
                          <tr key={i} className={`bg-rows ${i % 2 === 1 ? "bg-rows--even" : ""}`}>
                            <td className="bg-td">{i + 1}</td>
                            <td className="bg-td">{item.project_name || "-"}</td>
                            <td className="bg-td">{item.project_name_in_detail || "-"}</td>
                            <td className="bg-td">{item.bg || "-"}</td>
                            <td className="bg-td">{item.work_type || "-"}</td>
                            <td className="bg-td">{item.lead_firm || "-"}</td>
                            <td className="bg-td">{item.jv || "-"}</td>
                            <td className="bg-td">{item.association_firm || "-"}</td>
                            <td className="bg-td">{item.on_behalf_of || "-"}</td>
                            <td className="bg-td">{item.type || "-"}</td>
                            <td className="bg-td">{item.type_of_security || "-"}</td>
                            <td className="bg-td">{item.bank_gurentee_no || "-"}</td>
                            <td className="bg-td">{formatDate(item.bank_gurentee_issue_date)}</td>
                            <td className="bg-td">{formatDate(item.bg_expiry_date)}</td>
                            <td className="bg-td">{formatDate(item.claim_period)}</td>
                            <td className="bg-td">{item.benificiary_name || "-"}</td>
                            <td className="bg-td">{item.bg_amount || "-"}</td>
                            <td className="bg-td">{item.fd_number || "-"}</td>
                            <td className="bg-td">{item.margin || "-"}</td>
                            <td className="bg-td">{item.submitted_to_bd_dept || "-"}</td>
                            <td className="bg-td">{formatDate(item.submitted_date)}</td>
                            <td className="bg-td">{item.person_name || "-"}</td>
                            <td className="bg-td">{item.bank_name || "-"}</td>
                            <td className="bg-td">{item.company_name || "-"}</td>
                            <td className="bg-td">{item.limit || "-"}</td>
                            <td className="bg-td">{item.sfms || "-"}</td>
                            <td className="bg-td">{item.responsibility || "-"}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={27} className="bg-empty-row">No BG Old Data</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </>
            )}
          </div>

          {/* Status bar */}
          <div className="bg-statusbar">
            <strong>{tabRows.length}</strong> records
            <span className="bg-statusbar-sep">|</span>
            {selectedRows.length > 0 && (
              <>
                <strong>{selectedRows.length}</strong> selected
                <span className="bg-statusbar-sep">|</span>
              </>
            )}
            <span>
              Total EMD: ₹{tabRows.reduce((sum, i) => sum + (Number(String(i.emd_amount || "0").replace(/,/g, "")) || 0), 0).toLocaleString("en-IN")}
            </span>
          </div>
        </div>
        {showDownloadModal && (
          <DownloadModal
            onClose={() => setShowDownloadModal(false)}
            onDownload={handleDownloadChoice}
            loading={downloadLoading}
            title="Download EMD Details"
            options={[
              {
                value: "current",
                label: `Current tab only${isFilterActive ? " (filtered)" : ""}`,
                desc:
                  toggleState === 5
                    ? "Downloads BG Old records currently shown"
                    : "Downloads only the EMDs visible in this tab, honoring your active filters",
              },
              {
                value: "all",
                label: "All EMDs (every stage + BG Old)",
                desc: "One Excel file with every stage as its own sheet, ignoring current filters",
              },
            ]}
          />
        )}

        <ToastContainer
          position="top-center"
          autoClose={1000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    </>
  );
};


export default SubmittedTender;

